<template>
  <div class="live-wrapper df fdc aic f1 w100p">
    <!--  -->
    <!--  -->


    <div class="add-coffee-popup" v-if="showAddNewCoffeePopup || (showAddNewCoffeePopup === 0)" @click="hideAddCoffeePopup()">
      <div class="add-coffee-popup-inner whole-page-box-global-2 whole-page-box-global-2-unset posrel df fdc" @click="stopProp($event)">
        <h3 v-if="showAddNewCoffeePopup == 'NEW'">Add a new coffee</h3>
        <h3 v-else>Edit your coffee</h3>

        <!-- <br/> -->
        <div class="product-detail product-detail-add-new df _s5" @click="selectCoffeeType('New')" v-bind:class="{
          'not-selected-coffee-type': addNewCoffeeType !== 'New',
          'add-coffee-popup-inner-selected': addNewCoffeeType == 'New'
        }">
          <div class="check-detail f1">
            <h4>Coffee Name <span class="validation-error">{{addNewCoffeeValidationError}}</span></h4>
            <input v-model="addNewCoffeeInput" placeholder="Coffee Name" type="" name="">
            <div class="more-options df w100p aic" @click="setShowMoreNewCoffeeOptions(!showMoreNewCoffeeOptions)">
              <!-- <i v-if="showMoreNewCoffeeOptions" class="icon-chevron-up icon"></i> -->
              <img v-if="showMoreNewCoffeeOptions" src="../../static/images/icon-less-options.svg" class="more-less-options"></i>
              <img v-else src="../../static/images/icon-more-options.svg" class="more-less-options">
              <!-- <i v-else class="icon-chevron-down icon"></i> -->
              <p>{{showMoreNewCoffeeOptions ? 'Less' : 'More'}} Options</p>
            </div>
            <!--  -->
            <div class="more-options-open" v-if="showMoreNewCoffeeOptions">
              <!-- <h4>Blind Tasting Identifier</h4> -->
              <!-- <input v-model="addNewCoffeeBlindTastingIdentifier" placeholder="#1, A, etc." type="" name=""> -->
              <!-- <br/> -->
              <h4>Buy Now Link</h4>
              <input v-model="addNewCoffeeBuyNowLink" placeholder="http://" type="" name="">
              <br/>
              <!-- <h4>Product Image</h4> -->
                <h4>Thumbnail</h4>
                <div v-if="addNewCoffeeImageUrl" class="dropzone-wrapper image-dropzone-wrapper posrel df fdc aic jcc add-new-image-dropzone-wrapper">
                  <img class="image-uploaded" :src="addNewCoffeeImageUrl">
                  <a class="w100p tac image-uploaded-under" @click="removeProductImage()">Remove Image</a>
                </div>
                <div v-else class="dropzone-wrapper image-dropzone-wrapper posrel add-new-image-dropzone-wrapper">
                  
                  <vue-dropzone ref="myVueDropzone" 
                          id="dropzone-a"
                          class="image-upload"
                          @vdropzone-file-added="uploadedProductImage"
                          :options="dropzoneOptions">
                  </vue-dropzone>
                  <div class="dropzone-overlay df fdc">
                    <p>Drag Image Here</p>
                    <p>or</p>
                    <a class="button-b df aic jcc">Upload File</a>
                  </div>
                </div>
              <!-- <h4>Blind Tasting Identifier (ie, #1, A, etc)</h4> -->
              <!-- <input v-model="addNewCoffeeInput" placeholder="New Coffee" type="" name=""> -->
            </div>

          </div>
        </div>
        <div class="df _s6 aic">
          <h4 v-if="showAddNewCoffeePopup == 'New'" class="button-1 curp" @click="saveCoffee()">Add Coffee</h4>
          <h4 class="button-1 curp" v-else @click="saveCoffee()">Save</h4>
          <p class="cancel-add tac curp" @click="hideAddCoffeePopup()">Cancel</p>
          <p v-if="coffees.length > 1" class="cancel-add tac curp" @click="removeCoffeeFromTastingSession(showAddNewCoffeePopup)">Remove Coffee</p>
        </div>



        <div class="x-close curp" @click="hideAddCoffeePopup()"><i class="fal fa-times"></i></div>


      </div>
    </div>

    <!-- {{mode == 'cupping'}} -->
    <!-- {{$route}} -->
    <div class="session-will-start df fdc aifs w100p" v-if="!scoringStarted && !onCurrentCupping()">
      <div class="df w100p will-start-top">
        <h3 class="df fdr aic jcc pre-session">
          {{heading}}
        </h3>
        <p v-if="startsAt" class="df fdr aic jcc starts-at-button">
          <span>Starts {{formatDate(startsAt)}}</span>
        </p>
        <p v-else class="df fdr aic jcc starts-at-button">
          <span>Waiting For Host To Start</span>
        </p>
      </div>
      <span v-if="description && (description !== '<br>')" class="starts-at-desctiption mb_x w100p" v-html="description">
        <!-- {{description}} -->
      </span>
    </div>
    <span v-if="onCurrentCupping() && !$store.getters['AUTH.anonUser']" class="w100p back-arrow-main posrel">
      <img @click="goTo('/me')" src="../../static/images/back-arrow-main.svg" alt="">
      <p @click="goTo('/me')">Back</p>
    </span>
    <div v-if="onCurrentCupping()" class="session-will-start df fdc aifs w100p">
      <div class="df fdc w100p will-start-top">

        <div class="df fdc aifs mb_xy">
          <div v-if="editingField == 'heading'" class="edit-template-name w100p df aic">
            <input class="h3" type="text" :value="heading" @change="updateSessionDetail('heading', $event)" name="">
            <button class="button-1">Save</button>
            <a class="cancel-save" @click="editField(false)">Cancel</a>
          </div>
          <h3 v-else class="no-max-width df fdr aic jcc pre-session curp" @click="editField('heading')">
            {{heading}}
            <img class="edit-icon" src="../../static/images/icon-edit.svg">
          </h3>
          <div  class="df aic mt_x">
            <p class="df fdr aic jcc starts-at-button">
              <span>Live{{viewersCount ? ' (' + viewersCount + ' watching) ' : ''}}</span>
            </p>
            <img v-if="false" class="action-icon" src="../../static/images/icons-b/user-plus-light.svg">
            <p v-if="false" class="add-user-text">Add User</p>
          </div>
        </div>

        <select class="scoresheet-template-select input-a">
          <option v-for="(template, t) in tasting_templates" :value="tastingTemplate.name" @change="updateSessionDetail('heading', $event)">
            {{template.name}}
          </option>
        </select>
        
        <div class="df sheet-actions aic">
          <!-- <img class="action-icon-2" src="../../static/images/icons-b/floppy-disk-light.svg"> -->
          <!-- <p>invite friend</p> -->
          <!-- <p>add coffee</p> -->
          <!-- <p class="save-button">save</p> -->
          <div class="df w100p jcsb">
            <a @click="popupDescription(!showDescription)" class="show-hide-description" v-if="!showDescription">Show description</a>
            <span class="f1"></span>
            <a v-if="host()" @click="showAddCoffee()" class="show-hide-description">+ Add Coffee</a>
          </div>
        </div>

      </div>
      <p v-if="showDescription" class="starts-at-desctiption w100p">
        <span class="df fdc aifs" v-bind:class="{
            'description-open': showDescription
          }">
          <span class="df fdc jcfs w100p" v-if="showDescription">
            <h3 class="mb_y">Description</h3>
            <textarea class="input-1 edit-scoresheet-description" v-model="description" v-if="editingField == 'description'"></textarea>
            <div class="df save-description" v-if="editingField == 'description'">
              <button class="button-1 button-smaller save-description-button">Save</button>
              <button class="button-1 button-smaller save-description-button" @click="editField(false)">Cancel</button>
            </div>
            <span v-if="!(editingField == 'description')" class="shown-description" v-html="description"></span>
            <span class="password-scoring" v-if="passwordScoring && !noEvent">
              <p>This is a private cupping. Access scoring and description entry by using a special link from the host.</p>
            </span>
            <span v-if="host() && !(editingField == 'description')" class="w100p df mt_y">
              <a class="edit-description" @click="editField('description')">edit</a>
              <a @click="popupDescription(!showDescription)" class="edit-description cancel">{{editingField == 'description' ? 'cancel' : 'hide'}}</a>
            </span>
          </span>
          
        </span>
      </p>
<!--       <br/>
      <div class="df aic">
        <h3 class="df fdr aic jcc pre-session">
          My Scores
        </h3>
        <p>View another user</p>
      </div> -->
    </div>
    <div class="session-will-start df fdc aifs w100p" v-if="scoringStarted && scoringEnded && !onCurrentCupping">
      <div class="df w100p will-start-top">
        <h3 class="df fdr aic jcc pre-session">
          {{heading}}
        </h3>
        <p class="df fdr aic jcc starts-at-button">
          <span>Session Ended{{viewersCount ? ' (' + viewersCount + ' watching) ' : ''}}</span>
        </p>
        <!-- <div class="df w100p jcsb"> -->
          <a @click="popupDescription(!showDescription)" class="show-hide-description">{{showDescription ? 'Hide ' : 'Show '}} description</a>
          <!-- <a @click="showAddCoffee()" class="show-hide-description">+ Add Coffee</a> -->
        <!-- </div> -->
      </div>
      <p v-if="showDescription" class="starts-at-desctiption w100p">
        <span class="df fdc aifs" v-bind:class="{
            'description-open': showDescription
          }">
          <span class="df fww jcfs w100p" v-if="showDescription">
            <textarea v-if="editingField == 'description'"></textarea>
            <span v-else class="shown-description" v-html="description"></span>
            <span class="password-scoring" v-if="passwordScoring && !noEvent">
              <p>This is a private scoring event. The host will send you a special link to let you to score and describe coffees.</p>
            </span>
            <span v-if="host()" class="w100p df">
              <a class="edit-description" @click="editField('description')">edit</a>
            </span>
          </span>
          
        </span>
      </p>
    </div>

    <!--  -->
    <div class="add-coffee-popup" v-if="$store.getters['AUTH.showCuppingSettings']" @click="hideCuppingSettingsPopup()">
      <div class="add-coffee-popup-inner whole-page-box-global posrel" @click="stopProp($event)">
        <div class="popup-title-section">        
          <h3>Settings</h3>
        </div>

        <div v-if="host()" class="popup-data-section">
          <div class="settings df fdc">
            <span v-if="enableBlindCupping" class="sheet-option host-quick-actions jcsb df aic">
              <p class="f1">Reveal Coffees</p>
              <img @click="pushRevealCoffees(!revealed)" v-if="revealed" src="../../static/images/On.svg">
              <img @click="pushRevealCoffees(!revealed)" v-else src="../../static/images/Off.svg">
            </span>
            <span class="sheet-option host-quick-actions jcsb df aic">
              <p class="f1">Reveal Average Scores</p>
              <img @click="pushShowAverageScores(!averagesShown)" v-if="averagesShown" src="../../static/images/On.svg">
              <img @click="pushShowAverageScores(!averagesShown)" v-else src="../../static/images/Off.svg">
            </span>
            <span class="sheet-option host-quick-actions jcsb df aic">
              <p class="f1">Reveal Group Descriptors</p>
              <img @click="pushShowGroupDescriptors(!groupDescriptorsShown)" v-if="groupDescriptorsShown" src="../../static/images/On.svg">
              <img @click="pushShowGroupDescriptors(!groupDescriptorsShown)" v-else src="../../static/images/Off.svg">
            </span>
            <span class="sheet-option host-quick-actions jcsb df aic">
              <p class="f1">Reveal Polarization</p>
              <img @click="pushShowPolarization(!polarizationShown)" v-if="polarizationShown" src="../../static/images/On.svg">
              <img @click="pushShowPolarization(!polarizationShown)" v-else src="../../static/images/Off.svg">
            </span>
            <span class="sheet-option host-quick-actions jcsb df aic">
              <p class="f1">Lock Scoring</p>
              <img @click="pushLockScoring(!scoringLocked)" v-if="scoringLocked" src="../../static/images/On.svg">
              <img @click="pushLockScoring(!scoringLocked)" v-else src="../../static/images/Off.svg">
            </span>

            <br/>

            <span class="sheet-option df aic jcsb o005">
              <p class="f1">Light Mode</p>
              <img class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
              <!-- <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg"> -->
            </span>


            <!-- <span v-if="allowViewerAverageControl" class="sheet-option df aic jcsb">
              <p class="f1">Show Average Scores</p>
              <img @click="setShowAverageScores(!showAveragescores)" v-if="showAverageScores" src="../../static/images/On.svg">
              <img @click="setShowAverageScores(!showAveragescores)" v-else src="../../static/images/Off.svg">
            </span>  -->
            <!-- <input :checked="$store.getters['AUTH.colorMode']" @click="flipColorMode()" type="checkbox" name=""> -->
            <!-- <span class="sheet-option df aic jcsb">
              <p class="f1">Light Mode</p>
              <img @click="flipColorMode()" class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
              <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg">
            </span> -->


          </div>
        </div>
        <div v-else class="popup-data-section">
          <!-- <input :checked="$store.getters['AUTH.colorMode']" @click="flipColorMode()" type="checkbox" name=""> -->
            <span class="sheet-option df aic jcsb o005">
              <p class="f1">Light Mode</p>
              <img class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
              <!-- <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg"> -->
            </span>
        </div>

      </div>
    </div>
    <!-- SPLASH -->
      <div class="wrapper-2 w100p" v-if="!parts && !productFullDetails.noEvent && !onCurrentCupping()">

        <div v-bind:class="{
              'cupping-discussion-no-video': !enableVideo,
            }" class="live-cupping-top host-box df f1" v-if="host()">
         
          <div class="live-cupping-top-below df jcsb f1">
            <div class="live-cupping-questions mro df fdc f2 posrel" v-bind:style="{

            }">

              <div class="ask-a-question df fdc jcc posrel">
                <div class="question-bar df f100p jcsb aic">
                  <!-- <div class="curp back-from-question" v-if="replyToQuestion" @click="onUnFocusNewReply()">← Back</div> -->

                  <!-- <span v-if="host()" class="sheet-option host-quick-actions jcsb df aic w100p _mt0">
                    <p class="">Host View</p>
                    <img class="f1 switch-1" @click="pushLockScoring(!scoringLocked)" v-if="scoringLocked" src="../../static/images/On.svg">
                    <img @click="pushLockScoring(!scoringLocked)" v-else src="../../static/images/Off.svg">
                    <p class="">Cupper View</p>
                  </span> -->
                  <span class="sheet-option host-quick-actions jcsb df aic w100p">
                    <p class="section-title">Host Options</p>
                  </span>

                </div>
              </div>
              

              <div v-if="host()" class="popup-data-section">
                <div class="settings df fdc">
                  
                  <p class="settings-title _mt00">Session</p>
                  

                  <span v-if="scoringEnded" class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <p></p>
                    <a class="f1 mini-button mini-button-2">Session Ended</a>
                  </span>
                  <span @click="endSession()" v-else-if="scoringStartedF()" class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <p>End the session</p>
                    <a class="f1 mini-button mini-button-2">End Session</a>
                  </span>
                  <span v-else class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <p>Start the session</p>
                    <a @click="pushLockScoringStart(true)" class="f1 mini-button">Start Session</a>
                  </span>
                  <!-- 
                  <span v-if="scoringLocked" class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <a class="f1 mini-button">Unlock Scoring</a>
                    <p>Enable scoring and descriptor inputs</p>
                  </span>
                  <span v-else class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <a @click="pushLockScoringStart(true)" class="f1 mini-button">Lock Scoring</a>
                    <p>Disable scoring and descriptor inputs</p>
                  </span> -->

               <!--    <span class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <p class="f1">Start Session</p>
                    <p v-if="scoringStartedF()" class="started">✓</p>
                    <p @click="pushLockScoringStart(true)" class="start" v-else>Go</p>
                  </span> -->
                  <span class="sheet-option host-quick-actions jcsb df aic mtz">
                    <p class="f1">Lock Scoring</p>
                    <img @click="pushLockScoring(!scoringLocked)" v-if="scoringLocked" src="../../static/images/On.svg">
                    <img @click="pushLockScoring(!scoringLocked)" v-else src="../../static/images/Off.svg">
                  </span>

                  <br/>

                  <p class="settings-title">Reveal</p>
                  <span class="sheet-option host-quick-actions jcsb df aic _mt0">
                    <p class="f1">Average Scores</p>
                    <img @click="pushShowAverageScores(!averagesShown)" v-if="averagesShown" src="../../static/images/On.svg">
                    <img @click="pushShowAverageScores(!averagesShown)" v-else src="../../static/images/Off.svg">
                  </span>
                  <span v-if="enableBlindCupping" class="sheet-option host-quick-actions jcsb df aic">
                    <p class="f1">Coffees</p>
                    <img @click="pushRevealCoffees(!revealed)" v-if="revealed" src="../../static/images/On.svg">
                    <img @click="pushRevealCoffees(!revealed)" v-else src="../../static/images/Off.svg">
                  </span>
                  <span class="sheet-option host-quick-actions jcsb df aic">
                    <p class="f1">Group Descriptors</p>
                    <img @click="pushShowGroupDescriptors(!groupDescriptorsShown)" v-if="groupDescriptorsShown" src="../../static/images/On.svg">
                    <img @click="pushShowGroupDescriptors(!groupDescriptorsShown)" v-else src="../../static/images/Off.svg">
                  </span>
                  <span class="sheet-option host-quick-actions jcsb df aic">
                    <p class="f1">Polarization</p>
                    <img @click="pushShowPolarization(!polarizationShown)" v-if="polarizationShown" src="../../static/images/On.svg">
                    <img @click="pushShowPolarization(!polarizationShown)" v-else src="../../static/images/Off.svg">
                  </span>

                  <br/>

              <!--     <span class="sheet-option df aic jcsb o005">
                    <p class="f1">Light Mode</p>
                    <img class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
                    <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg">
                  </span> -->


                  <!-- <span v-if="allowViewerAverageControl" class="sheet-option df aic jcsb">
                    <p class="f1">Show Average Scores</p>
                    <img @click="setShowAverageScores(!showAveragescores)" v-if="showAverageScores" src="../../static/images/On.svg">
                    <img @click="setShowAverageScores(!showAveragescores)" v-else src="../../static/images/Off.svg">
                  </span>  -->
                  <!-- <input :checked="$store.getters['AUTH.colorMode']" @click="flipColorMode()" type="checkbox" name=""> -->
                  <!-- <span class="sheet-option df aic jcsb">
                    <p class="f1">Light Mode</p>
                    <img @click="flipColorMode()" class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
                    <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg">
                  </span> -->


                </div>
              </div>
              <div v-else class="popup-data-section">
                <!-- <input :checked="$store.getters['AUTH.colorMode']" @click="flipColorMode()" type="checkbox" name=""> -->
                  <span class="sheet-option df aic jcsb o005">
                    <p class="f1">Light Mode</p>
                    <img class="curp" v-if="$store.getters['AUTH.colorMode']" src="../../static/images/On.svg">
                    <!-- <img @click="flipColorMode()" class="curp" v-else src="../../static/images/Off.svg"> -->
                  </span>
              </div>







            </div>
          </div>
        </div> 






        <div v-bind:class="{
              'cupping-discussion-no-chat': !enableChat,
            }" class="live-cupping-video df fdc jcsb" v-if="enableVideo">
          <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/' + youtubeVideoID + '?autoPlay=1&showinfo=0&controls=1&autohide=1&disablekb=1&fs=0&modestbranding=1&playsinline=1'" frameborder="0" allowfullscreen></iframe>
          <!-- <iframe width="100%" height="100%" :src="'https://www.youtube.com/embed/' + youtubeVideoID + '?autoPlay=1&showinfo=0&controls=0&autohide=1&disablekb=1&fs=0&modestbranding=1&playsinline=1'" frameborder="0" allowfullscreen></iframe> -->
            <!-- <h2>{{viewersCount ? '(' + viewersCount + ' watching) ' : ''}}{{heading}} <a @click="popupDescription(!showDescription)">({{showDescription ? 'hide ' : 'show '}} description)</a></h2> -->
<!--           <div class="video-meta" v-bind:class="{
            'description-open': showDescription
          }">
            <div class="df fww" v-if="showDescription">
              <p>{{description}}</p>
              <div class="password-scoring" v-if="passwordScoring">
                <p>This is a private scoring event. The host will send you a special link to let you to score and describe coffees.</p>
              </div>
            </div>
          </div> -->

<!--               <p v-if="passwordScoring">
                &nbsp;({{numberOfUsers}} cupper{{numberOfUsers == 1 ? '' : 's'}})
              </p> -->

          <!-- <iframe :width="videoWidth()" :height="videoHeight()" :src="'https://www.youtube.com/embed/' + youtubeVideoID + '?autoPlay=1&showinfo=0&controls=0&autohide=1&disablekb=1&fs=0&modestbranding=1&playsinline=1'" frameborder="0" allowfullscreen></iframe> -->
        </div>

        <div v-bind:class="{
              'cupping-discussion-no-video': !enableVideo,
            }" class="live-cupping-top chat-outer df f1 w100p" v-if="enableChat">
         
          <div class="live-cupping-top-below df jcsb f1 w100p">
            <div class="live-cupping-questions df fdc f2 posrel" v-bind:style="{

            }">


              <div class="ask-a-question df fdc jcc posrel" v-bind:class="{
                  'active-question-bar': showFullNewMessageInput
                }">
                <div class="question-bar df f100p jcsb aic">
                  <div class="curp back-from-question" v-if="replyToQuestion" @click="onUnFocusNewReply()">← Back</div>

                  <div class="question-wrap w100p df aic posrel" v-else-if="!showFullNewMessageInput">
                    <div class="ask-a-question-input-initials">
                      <!-- {{$store.getters['AUTH.uid'].slice(0, 2)}} -->
                      {{($store.getters['AUTH.myPublicData'].displayName && $store.getters['AUTH.myPublicData'].displayName.slice(0, 2)) || ($store.getters['AUTH.uid'].slice(0, 2))}}
                    </div>
                    <input class="ask-a-question-input f1" @focus="onFocusNewMessage()" v-model="newQuestion" placeholder="Share your thoughts" type="text"/>
                  </div>
                  <div v-else class="user-question-top w100p df fdc">
                    <div class="question-user df aic">
                      <span class="ask-a-question-input-initials _posrel">{{($store.getters['AUTH.myPublicData'].displayName && $store.getters['AUTH.myPublicData'].displayName.slice(0, 2)) || ($store.getters['AUTH.uid'].slice(0, 2))}}</span>
                      <div class="question-user-name-location df fdc">
                        <p>{{($store.getters['AUTH.myPublicData'].displayName) || ('User ' + $store.getters['AUTH.uid'].slice(0, 6))}}</p>
                        <!-- <p>New York, NY</p> -->
                      </div>
                    </div>
                    <div class="df w100p">
                      <input class="ask-a-question-input f1" v-model="newQuestion" placeholder="Share your thoughts" type="text"/>
                    </div>
                    <div class="actions df jcfe">
                      <!-- <p>upload file</p> -->
                      <button class="ask-a-question-button cancel-button" @click="onUnFocusNewMessage()">Cancel</button>
                      <button class="ask-a-question-button post-button" v-bind:class="{
                        'active-post-button': newQuestion.length > 0
                      }" @click="askAQuestion(askingQuestion)">{{askingQuestion ? 'Posting...' : 'Post'}}</button>
                    </div>
                  </div>
                </div>
              </div>

                      <!-- <span v-if="question.reply || Object.keys(question.plusOnes || {}).length > 0" class="questions-replies"> -->

                        <!-- <span class="mr15" v-if="Object.keys(question.plusOnes || {}).length > 0">&nbsp;{{Object.keys(question.plusOnes || {}).length}} like{{Object.keys(question.plusOnes || {}).length == 1 ? '' : 's'}}</span> -->

                        <!-- <span v-if="question.reply">1 comment</span> -->
                      <!-- </span> -->
              

            <div class="questions-list-wrapper">
              <div class="live-qupping-questions-list df fdcr f1" id="live-qupping-questions-list" v-bind:class="{
                'active-live-cupping-questions': showFullNewMessageInput
              }">
                <div class="df fdc" v-for="(question, i) in liveQuestions" v-if="((replyToQuestion == i) || !replyToQuestion) && !question.trashed">
                  <div class="user-question df fdc">
                    <div class="user-question-top w100p df fdc">

                      <div class="delete-comment">
                        <i class="fal fa-trash" v-if="host()" @click="trashComment(i)"></i>
                        <i class="fal fa-times" v-if="!question.deleted && (host() || (question.uid == $store.getters['AUTH.uid']))" @click="deleteComment(i)"></i>
                      </div>
                      <div class="question-user df aic">
                        <span class="ask-a-question-input-initials _posrel">{{(question.name && question.name.slice(0, 2)) || (question.uid && question.uid.slice(0, 2))}}</span>
                        <div class="question-user-name-location df fdc">
                          <p>{{question.name || ('User ' + (question.uid && question.uid.slice(0, 6)))}}</p>
                          <!-- <p>User {{question.uid.slice(0, 6)}}</p> -->
                          <!-- <p>{{question.location}}</p> -->
                        </div>
                      </div>
                      <p class="user-comment">
                        {{question.deleted ? '[deleted]' : question.question}}
                      </p>

                      <span v-if="question.reply || Object.keys(question.plusOnes || {}).length > 0" class="questions-replies">

                        <span class="mr15" v-if="Object.keys(question.plusOnes || {}).length > 0">&nbsp;{{Object.keys(question.plusOnes || {}).length}} like{{Object.keys(question.plusOnes || {}).length == 1 ? '' : 's'}}</span>

                        <span @click="startReplyToQuestion(i)" class="curp" v-if="question.reply">{{Object.keys(question.reply || {}).length}} comment{{Object.keys(question.reply || {}).length == 1 ? '' : 's'}}</span>
                      </span>
                      <!-- <div class="w100p reply-to-question-wrap" v-bind:class="{
                        'mb15': question.reply
                      }">
                        <span v-if="question.reply" class="reply-to-question">
                          <p>
                            <strong>Host Answer:</strong> {{question.reply}}
                          </p>
                        </span>
                      </div> -->
                    </div>


                    <div class="user-question-bottom df">
                      <span class="dif curp">
                        <img src="../../static/images/like.svg" @click="plusOneAQuestion(i)">
                        <p class="like-and-comment" @click="plusOneAQuestion(i)">Like</p>
<!--                         <i class="fa fa-thumbs-up question-plus-one" v-bind:class="{
                        'my-plus-one': $store.getters['AUTH.uid'] && question.plusOnes && question.plusOnes[$store.getters['AUTH.uid']]
                      }" @click="plusOneAQuestion(i)"></i> -->
                      </span>
                      <span class="dif curp">
                        <img class="comment-icon" src="../../static/images/comment.svg" @click="startReplyToQuestion(i)">
                        <p class="like-and-comment" @click="startReplyToQuestion(i)">
                          Comment
                        </p>
                      </span>
                    </div>



                    <div class="question-comments df fdc" v-if="replyToQuestion && question.reply">
                      <div class="one-comment df" v-for="(comment, commentId) in question.reply" v-if="!comment.trashed">
                        <span class="ask-a-question-input-initials smaller-initials _posrel">{{((comment.name && comment.name.displayName) && comment.name.displayName.slice(0, 2)) || (comment.uid ? comment.uid.slice(0, 2) : '...')}}</span>
                        <div class="comment-full user-question-top f1">

                        <div class="delete-comment">
                          <i class="fal fa-trash" v-if="host()" @click="trashReply(i, commentId)"></i>
                          <i class="fal fa-times" v-if="!question.deleted && (host() || (comment.uid == $store.getters['AUTH.uid']))" @click="deleteReply(i, commentId)"></i>
                        </div>


                          <div class="question-user-name-location question-user-name-location-2 df fdc">
                            
                          <p>{{(comment.name && comment.name.displayName) || ('User ' + (comment.uid ? comment.uid.slice(0, 6) : '...'))}}</p>
                            <!-- <p>Toronto</p> -->
                          </div>
                          <p class="full-comment-text">
                            {{comment.deleted ? '[deleted]' : comment.message}}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div v-if="replyToQuestion === i" class="reply-box w100p" v-bind:class="{
                      'active-live-cupping-questions': showFullReplyInput
                    }">
                      <div class="question-wrap w100p df fdc aic">
                      <!--   <div class="ask-a-question-input-wrap w100p posrel comment-box" v-if="!showFullReplyInput">
                          <div class="ask-a-question-input-initials">
                            VB
                          </div>
                          <input @focus="onFocusNewReply()" class="ask-a-question-input f1" v-model="answerToQuestion" placeholder="Reply to the question" type="text"/>
                        </div> -->


                        <div class="user-question-top comment-box w100p df fdc">
                          <div class="question-user df aic">
                            <span class="ask-a-question-input-initials _posrel">{{($store.getters['AUTH.myPublicData'].displayName && $store.getters['AUTH.myPublicData'].displayName.slice(0, 2)) || ($store.getters['AUTH.uid'].slice(0, 2))}}</span>
                            <div class="question-user-name-location df fdc">
                              <p>{{($store.getters['AUTH.myPublicData'].displayName) || ('User ' + $store.getters['AUTH.uid'].slice(0, 6))}}</p>
                              <!-- <p>New York, NY</p> -->
                            </div>
                          </div>
                          <input id="your-reply" class="ask-a-question-input f1" v-model="newReply" placeholder="Your reply" type="text"/>
                          <div class="actions df jcfe">
                            <button class="ask-a-question-button cancel-button" @click="onUnFocusNewReply()">Cancel</button>
                            <button class="ask-a-question-button post-button" v-bind:class="{
                              'active-post-button': newReply.length > 0
                            }" @click="answerReplyToQuestion(replyingToQuestion)">{{replyingToQuestion ? 'Posting...' : 'Post'}}</button>
                          </div>
                        </div>


                        <!-- <button class="ask-a-question-button" @click="answerReplyToQuestion()">Go</button>
                        <p class="end-reply" @click="endReplyToQuestion()">Cancel</p> -->
                      </div>
                      
                    </div>

                  </div>
                </div>
              </div>
            </div>






            </div>
          </div>
        </div>  
      </div>    

<!--       <div class="password-scoring" v-if="passwordScoring">
        <p>Enter </p>
      </div> -->


      <!--    <div class="cupping-steps df fdc f1">
            <div class="df aic jcsb cupping-top">
              <div class="step-description f1 df aic jcsb">
                <p class="cupping-with">Cupping with Tony "Tonx" Konecny</p>
              </div>
            </div>
            <div  v-for="(step, i) in cuppingSteps"
                  class="cupping-step1 df jcsb w100p"
                  v-bind:class="{
                  'current-step': currentStep === i
                }"
                @click="setCurrentStep(i)">


                <div class="step-wrap df fdc">
                  <div class="step-wrap-top df jcsb w100p">
                    <a class="cupping-step-name f1">{{i + 1}}. {{step.name}}</a>
                    <p class="cupping-step-arrow" v-if="currentStep === i">
                      ←
                    </p>
                  </div>
                  <div class="step-wrap-bottom">
                    <p class="step-description" v-if="currentStep === i">
                      {{cuppingSteps[currentStep].name}}: {{cuppingSteps[currentStep].instruction}}
                    </p>
                  </div>
                </div>
          </div> -->
        <!-- </div> -->

        <!-- Flavor wheel test -->
        <!-- <FlavorWheel /> -->
    <!-- STEP DESCRIPTION -->
<!--     <div class="step-description f1 df fdc aic jcc w100p">
      <h2>
        {{cuppingSteps[currentStep].name}}
      </h2>
      <p>
        {{cuppingSteps[currentStep].instruction}}
      </p>
    </div> -->

    <!-- SCORING CHART -->
    <div class="live-current-step w100p df"
        v-bind:class="{
          'horizontal-scoring-view': showHorizontalView,
          'no-top-margin': parts,
          'no-video-no-chat': !enableVideo && !enableChat
        }">

 <!--        <div class="current-step-overlay" v-if="passwordScoring">
          test
        </div> -->

<!-- 
        <div class="coffees df jcsb w100p">
          <div class="one-coffee fdc" v-for="(coffee, n) in coffees"
          v-bind:class="{
            'blue-bag': coffee.bag == 'blue',
            'green-bag': coffee.bag == 'green',
            'yellow-bag': coffee.bag == 'yellow',
            'orange-bag': coffee.bag == 'orange',
          }">
            <span class="one-coffee-bag df aic jcc">            
              <img :src="coffee.thumbnail"/>
              <p>
                {{coffee.name}}
              </p>
            </span>

          </div>
        </div>

        <div  class="cupping-step"
        v-for="(step, i) in cuppingSteps"
        v-if="step.scoring">
        </div> -->

      <div class="coffees">
        
          <div class="metric-title">
            <div class="one-coffee-bag nobg df aic jcsb">
              <div class="legend">
                <div class="df" v-if="averagesShown">
                  <span class="legend-square average-score-square"></span>
                  <span class="legend-text">Average Score</span>
                </div>
                <div class="df mt7">
                  <span class="legend-square my-score-square"></span>
                  <span class="legend-text" @click="revealRefresh()">My Score</span>
                </div>
              </div>
              <span></span>
              <span></span>
            </div>
            <div class="coffee-my-things coffee-my-things-title df fdc">


              <!-- CUPPING STEP START -->
              <div  class="cupping-step df fdc"
                    v-bind:class="{
                      'smaller-step': step.smallerDisplay 
                    }"
                    v-for="(step, i) in tastingTemplate.steps"
                    v-if="step.scoring">
                    

                <!-- Start of Step's Metrics -->
                <div class="one-score-metric one-score-metric-color one-score-metric-name df fdr jcfe w100p" v-for="(metric, j) in step.metrics"
                        v-bind:class="{
                        'roast-level-vertical': metric.scoring.type == 'roast-level-vertical',
                        'scale-horizontal': metric.scoring.type == 'scale-horizontal-2',
                        'scale-vertical': metric.scoring.type == 'scale-vertical-2',
                        'descriptors-vertical': metric.scoring.type == 'descriptors-vertical',
                      }">

                  <!-- Step dropdown bar -->
                 <!--  <div class="step-title df jcsb aic w100p" v-if="n === 0 && j === 0" 
                    v-bind:class="{
                      'current-step-title': currentStep === i
                    }" @click="toggleShowStep(i)">
                    <h2>{{step.name}}</h2>
                    <p v-if="showSteps.indexOf(i) > -1">▲</p>
                    <p v-else>▼</p>
                  </div> -->


                    <!-- Metric Name -->
                    <div class="one-score-title df fdc metric-title-name aife w100p"
                          v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                      <p>
                        {{metric.name}}
                      </p>

                      <!-- <input type="number" step="0.1" v-model="weights[i.toString() + '-' + j.toString()]" name=""> -->
                      <p class="smaller-text">Weight: {{weights[i.toString() + '-' + j.toString()]}}</p>
                    </div> 
                </div>
                <div v-if="polarizationShown" class="one-score-metric one-score-metric-color one-score-metric-name df fdr w100p">
                    <!-- Metric Name -->
                    <div class="one-score-title metric-title-name special-metric w100p">
                      <p>
                        Polarization
                      </p>
                    </div> 
                </div>
                <div v-if="groupDescriptorsShown" class="one-score-metric one-score-metric-color word-cloud-title one-score-metric-name df fdr w100p">
                    <!-- Metric Name -->
                    <div class="one-score-title metric-title-name special-metric w100p">
                      <p>
                        Group Descriptors
                      </p>
                    </div> 
                </div>
                <div class="one-score-metric one-score-metric-color word-cloud-title one-score-metric-name df fdr w100p f1">
                    <!-- Metric Name -->
                    <div class="one-score-title metric-title-name special-metric w100p">
                      <p>
                        My Descriptors
                      </p>
                    </div> 
                </div>
              </div>
            </div>

          </div>
      </div>
      <!-- <VueSlickCarousel v-if="loaded"
                        :infinite="true"
                        :slidesToScroll="1" 
                        :slidesPerRow="slidesPerRow()" 
                        :arrows="true" 
                        :dots="false" 
                        class="coffees coffees-2 w100p df jcsb w100p" 
                        v-bind:class="{
        ['color-' + colorModeOption]: true 
      }"> -->  
<!--       <carousel :per-page="1" :navigate-to="someLocalProperty" :mouse-drag="false">
        <slide>
          Slide 1 Content
        </slide>
        <slide>
          Slide 2 Content
        </slide>
      </carousel> -->

      <!-- <i class="custom-nav nav-prev fal fa-chevron-circle-left" @click="prevSlide()"></i> -->
      <!-- <i class="custom-nav nav-next fal fa-chevron-circle-right" @click="nextSlide()"></i> -->
      <carousel @page-change="slideChange" :per-page="slidesPerRow" :navigateTo="currentSlide" :paginationEnabled="false" :touch-drag="false" :mouse-drag="false" :loop="true" :navigationEnabled="true"
      :navigation-next-label="nextLabel"
      :navigation-prev-label="prevLabel" class="coffees coffees2 df jcsb w100p">
<!--       <div class="coffees df jcsb w100p"> -->
        <slide class="one-coffee-wrap" v-for="(coffee, n) in coffees" :key="'slide-' + n"
        v-if="!parts || parts.indexOf(n + 1) > -1"
        v-bind:class="{
        }">
          <div class="one-coffee f1">
            <span class="one-coffee-bag df fdr aic jcsb" v-bind:class="{
              ['color-' + ((parseInt(n)%4) + 1)]: true
            }">
            <!-- && coffee.imageUrl -->
              <!-- <img :src="coffee.imageUrl" class="coffee-image" v-if="colorMode"> -->
              <!-- <img :src="coffee.imageUrl" class="coffee-image" v-else-if="colorMode"> -->
              <span class="coffee-image initials">
                <p>
                  {{enableBlindCupping ? (revealed ? (coffee.name ? coffee.name.substring(0, 2) : '') : coffee.blindTastingId.substring(0, 2)) : (coffee.name ? coffee.name.substring(0, 2) : '')}}
                </p>
              </span>

              <div class="bag-name-wrap df fdc f1 aifs">
                
                <input v-if="editingCoffee && (editingCoffee[0] === n)" v-model="coffee.name" @change="(updateCoffeeDetail(n, 'title', $event))" type="text" name="">
                <p v-else class="bag-title df aic">{{enableBlindCupping ? (revealed ? coffee.name : coffee.blindTastingId) : coffee.name}} <img class="edit-coffee-name" src="../../static/images/icon-new-edit.svg" v-if="host() && onCurrentCupping()" @click="editCoffee(n, 'name')"></p>


                <p class="bag-title bag-title-score">{{coffeeScore(n)}}/{{templateScore(tastingTemplate)}} {{(averagesShown) ? '(Average: ' + averageCoffeeScore(n) + ')' : ''}}</p>
              </div>
            </span>


            <div class="coffee-my-things df fdc">

              <!-- CUPPING STEP START -->
              <div  class="cupping-step df fdc aic"
                    v-bind:class="{
                      'smaller-step': step.smallerDisplay 
                    }"
                    v-for="(step, i) in tastingTemplate.steps"
                    v-if="step.scoring">
                    

                <!-- Start of Step's Metrics -->
                <div class="one-score-metric one-score-metric-color df fdr w100p" v-for="(metric, j) in step.metrics"
                        v-bind:class="{
                        'scoring-locked-metric': (scoringLocked || !scoringStartedF() || !scoringAllowed()) && !onCurrentCupping(),
                        'roast-level-vertical': metric.scoring.type == 'roast-level-vertical',
                        'scale-horizontal': metric.scoring.type == 'scale-horizontal',
                        'scale-vertical': metric.scoring.type == 'scale-vertical',
                        'descriptors-vertical': metric.scoring.type == 'descriptors-vertical',
                      }">

                  <div class="df fdc f1 w100p"
                          v-bind:class="{'jcc': metric.scoring.type == 'number-magnitude-k'}"
                          v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                          <!-- BARS. -->
                    <div class="averages-bars df jcsb aife" v-if="(metric.scoring.type == 'scale-horizontal') && averageSpread[n] && averagesShown">
                      <div v-for="(bar, k) in averageSpread[n][i][j]" class="averages-bar f1" :style="{
                        height: bar + 'px'
                      }">
                      </div>
                    </div>
                    <!-- Metric Name -->
                    <div class="one-score-title"
                          v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                      <p>
                        &nbsp;
                      </p>
                    </div> 


                    <!-- Metric Type: check-x-times-k -->
                    <div class="one-score-select nmk-one-score-select df aic w100p jcsb"
                          v-if="((showSteps.indexOf(i) > -1) || showHorizontalView) && (metric.scoring.type == 'check-x-times-k')">
                          <div class="check-x-boxes df jcc aic w100p">
                            <span v-for="(check, z) in metric.scoring.x" class="df fdc aic jcc">
                              <input v-model="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score[z]" type="checkbox" name="" @click="setCheckInput(n, i, j, z, myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score[z] ? (!myScores[n].steps[i].metrics[j].score[z] || false) : true) : false)">
                              <p>{{z + 1}}</p>
                            </span>
                          </div>

                          <!-- <div class="my-scores-number-magnitude-k df aic jcc w100p">
                            <div class="df lift_1 mr_x">
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.number ? myScores[n].steps[i].metrics[j].score.number : 0) - 1 : 0}}, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')">
                                <img src="../../static/images/minus.png">
                              </span>

                              <input v-if="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.number" v-model="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.number" @input="checkInput($event, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')" type="number" class="number nmk-input" :min="metric.scoring.number.min" :max="metric.scoring.number.max" :step="metric.scoring.number.increment"></input>
                              <input v-else @input="checkInput($event, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')" :placeholder="metric.scoring.number.name" type="number" class="number nmk-input" :min="metric.scoring.number.min" :max="metric.scoring.number.max" :step="metric.scoring.number.increment"></input>
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.number ? myScores[n].steps[i].metrics[j].score.number : 0) + 1 : 1}}, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')">
                                <img src="../../static/images/plus.png">
                              </span>
                            </div>
                            <p class="lift_2 magnitude-x">+</p>
                            <div class="df lift_1 mr_x ml_x">
                              
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.magnitude ? myScores[n].steps[i].metrics[j].score.magnitude : 0) - 1 : 0}}, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')">
                                <img src="../../static/images/minus.png">
                              </span>
                              <input v-if="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.magnitude" v-model="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.magnitude" @input="checkInput($event, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')" type="number" class="number nmk-input" :min="metric.scoring.magnitude.min" :max="metric.scoring.magnitude.max" :step="metric.scoring.magnitude.increment"></input>
                              <input v-else @input="checkInput($event, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')" :placeholder="metric.scoring.magnitude.name" type="number" class="number nmk-input" :min="metric.scoring.magnitude.min" :max="metric.scoring.magnitude.max" :step="metric.scoring.magnitude.increment"></input>
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.magnitude ? myScores[n].steps[i].metrics[j].score.magnitude : 0) + 1 : 1}}, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')">
                                <img src="../../static/images/plus.png">
                              </span>

                            </div>
                            <p v-if="metric.scoring.k !== 1" class="lift_2 magnitude-x">+</p>
                            <p v-if="metric.scoring.k !== 1" class="number-magnitude-k-k lift_2 lift_3 ml_x">{{metric.scoring.k}}</p>
                          </div> -->
                          <!-- <div class="bars df w100p jcsb">
                            
                            <div class="increment increment-down" @click="changeScoreValue(-0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                              <p>
                                -
                              </p>
                            </div>
                            <div class="df fdc f1">
                              <div class="rating-bar group-rating">
                                <div class="bar-fill group-bar-fill" v-bind:style="{
                                  width: barWidth(n, i, j, metric.scoring.from, metric.scoring.to) + '%',
                                  opacity: (showAverageScores || averagesShown) ? 0.6 : 0
                                }"></div>
                              </div>
                              <div class="rating-bar my-rating">
                                  <vue-slider v-if="loaded && myScores[n]" :width="'100%'"
                                    :max="metric.scoring.to"
                                    :min="metric.scoring.from"
                                    :interval="metric.scoring.increment"
                                    :style="{
                                      'height': '12px',
                                      'padding': 0
                                    }"
                                    :railStyle="{
                                      'height': '12px',
                                      'borderRadius': 0,
                                      'backgroundColor': $store.getters['AUTH.colorMode'] ? '#cdcdcd' : '#555'
                                    }"
                                    :stepStyle="{
                                      'display': 'flex',
                                      'backgroundColor': '#cacaca',
                                      'borderRadius': 0,
                                      'boxShadow': 'none',
                                      'width': '1px'
                                    }"
                                    :processStyle="{
                                      'backgroundColor': bagColor(coffee.bag),
                                      'boxShadow': '#eeeeee',
                                      'borderRadius': 0,
                                    }"
                                    :tooltipStyle="{
                                      height: '25px',
                                      width: '25px',
                                      padding: 0,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      'backgroundColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                      'borderColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                      color: $store.getters['AUTH.colorMode'] ? '#444' : '#ddd'
                                    }"
                                    :dotOptions="{
                                      tooltip: 'always'
                                    }"
                                    :dotStyle="{
                                      display: 'none',
                                      'borderRadius': 0,
                                      'boxShadow': 'transparent',
                                      'backgroundColor': 'transparent',
                                      'borderColor': 'transparent',
                                      'backgroundSize': 'contain',
                                      'backgroundRepeat': 'no-repeat',
                                      'backgroundPosition': 'center',
                                      'height': '50px',
                                      'width': '50px',
                                      'top': '0',
                                      'transform': 'translate(-17.5px, -65px)',
                                    }"
                                    :marks="staticMarksObject"
                                    v-model="myScores[n].steps[i].metrics[j].score"
                                    @change="testf($event, metric.scoring.from, metric.scoring.to, n, i, j)" />
                              </div>
                            </div>
                            <div class="increment increment-up"  @click="changeScoreValue(0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                              <p>
                                +
                              </p>
                            </div>
                          </div> -->
                    </div> 

                    <!-- Metric Type: number-magnitude-k -->
                    <div class="one-score-select nmk-one-score-select df aic w100p jcsb"
                          v-if="((showSteps.indexOf(i) > -1) || showHorizontalView) && (metric.scoring.type == 'number-magnitude-k')">
                          <div class="my-scores-number-magnitude-k df aic jcc w100p">
                            <div class="df lift_1 mr_x">
                              <!-- <p class="number-magnitude-k-subheading">{{metric.scoring.number.name}}</p> -->
                              
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.number ? myScores[n].steps[i].metrics[j].score.number : 0) - 1 : 0}}, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')">
                                <img src="../../static/images/minus.png">
                              </span>

                              <input v-if="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.number" v-model="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.number" @input="checkInput($event, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')" type="number" class="number nmk-input" :min="metric.scoring.number.min" :max="metric.scoring.number.max" :step="metric.scoring.number.increment"></input>
                              <input v-else @input="checkInput($event, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')" :placeholder="metric.scoring.number.name" type="number" class="number nmk-input" :min="metric.scoring.number.min" :max="metric.scoring.number.max" :step="metric.scoring.number.increment"></input>
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.number ? myScores[n].steps[i].metrics[j].score.number : 0) + 1 : 1}}, metric.scoring.number.min, metric.scoring.number.max, [n, i, j], 'number')">
                                <img src="../../static/images/plus.png">
                              </span>
                            </div>
                            <p class="lift_2 magnitude-x">+</p>
                            <div class="df lift_1 mr_x ml_x">
                              <!-- <p class="number-magnitude-k-subheading">{{metric.scoring.magnitude.name}}</p> -->
                              
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.magnitude ? myScores[n].steps[i].metrics[j].score.magnitude : 0) - 1 : 0}}, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')">
                                <img src="../../static/images/minus.png">
                              </span>
                              <input v-if="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.magnitude" v-model="myScores[n].steps[i].metrics[j].score && myScores[n].steps[i].metrics[j].score.magnitude" @input="checkInput($event, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')" type="number" class="number nmk-input" :min="metric.scoring.magnitude.min" :max="metric.scoring.magnitude.max" :step="metric.scoring.magnitude.increment"></input>
                              <input v-else @input="checkInput($event, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')" :placeholder="metric.scoring.magnitude.name" type="number" class="number nmk-input" :min="metric.scoring.magnitude.min" :max="metric.scoring.magnitude.max" :step="metric.scoring.magnitude.increment"></input>
                              <span class="minus-nmk-input" @click="checkInput({target:{value: myScores[n].steps[i].metrics[j].score ? (myScores[n].steps[i].metrics[j].score.magnitude ? myScores[n].steps[i].metrics[j].score.magnitude : 0) + 1 : 1}}, metric.scoring.magnitude.min, metric.scoring.magnitude.max, [n, i, j], 'magnitude')">
                                <img src="../../static/images/plus.png">
                              </span>
                              



                            </div>
                            <p v-if="metric.scoring.k !== 1" class="lift_2 magnitude-x">+</p>
                            <p v-if="metric.scoring.k !== 1" class="number-magnitude-k-k lift_2 lift_3 ml_x">{{metric.scoring.k}}</p>
                          </div>
                      <!-- <div class="bars df w100p jcsb">
                        
                        <div class="increment increment-down" @click="changeScoreValue(-0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                          <p>
                            -
                          </p>
                        </div>
                        <div class="df fdc f1">
                          <div class="rating-bar group-rating">
                            <div class="bar-fill group-bar-fill" v-bind:style="{
                              width: barWidth(n, i, j, metric.scoring.from, metric.scoring.to) + '%',
                              opacity: (showAverageScores || averagesShown) ? 0.6 : 0
                            }"></div>
                          </div>
                          <div class="rating-bar my-rating">
                              <vue-slider v-if="loaded && myScores[n]" :width="'100%'"
                                :max="metric.scoring.to"
                                :min="metric.scoring.from"
                                :interval="metric.scoring.increment"
                                :style="{
                                  'height': '12px',
                                  'padding': 0
                                }"
                                :railStyle="{
                                  'height': '12px',
                                  'borderRadius': 0,
                                  'backgroundColor': $store.getters['AUTH.colorMode'] ? '#cdcdcd' : '#555'
                                }"
                                :stepStyle="{
                                  'display': 'flex',
                                  'backgroundColor': '#cacaca',
                                  'borderRadius': 0,
                                  'boxShadow': 'none',
                                  'width': '1px'
                                }"
                                :processStyle="{
                                  'backgroundColor': bagColor(coffee.bag),
                                  'boxShadow': '#eeeeee',
                                  'borderRadius': 0,
                                }"
                                :tooltipStyle="{
                                  height: '25px',
                                  width: '25px',
                                  padding: 0,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  'backgroundColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                  'borderColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                  color: $store.getters['AUTH.colorMode'] ? '#444' : '#ddd'
                                }"
                                :dotOptions="{
                                  tooltip: 'always'
                                }"
                                :dotStyle="{
                                  display: 'none',
                                  'borderRadius': 0,
                                  'boxShadow': 'transparent',
                                  'backgroundColor': 'transparent',
                                  'borderColor': 'transparent',
                                  'backgroundSize': 'contain',
                                  'backgroundRepeat': 'no-repeat',
                                  'backgroundPosition': 'center',
                                  'height': '50px',
                                  'width': '50px',
                                  'top': '0',
                                  'transform': 'translate(-17.5px, -65px)',
                                }"
                                :marks="staticMarksObject"
                                v-model="myScores[n].steps[i].metrics[j].score"
                                @change="testf($event, metric.scoring.from, metric.scoring.to, n, i, j)" />
                          </div>
                        </div>
                        <div class="increment increment-up"  @click="changeScoreValue(0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                          <p>
                            +
                          </p>
                        </div>
                      </div> -->
                    </div> 

                    <!-- Metric Type: scale-horizontal -->
                    <div class="one-score-select df aic w100p jcsb"
                          v-if="((showSteps.indexOf(i) > -1) || showHorizontalView) && (metric.scoring.type == 'scale-horizontal')">
                      <div class="bars df w100p jcsb">
                        
                        <div class="increment increment-down" @click="changeScoreValue(-0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                          <p>
                            -
                          </p>
                        </div>
                        <div class="df fdc f1">
                          <div class="rating-bar group-rating">
                            <div class="bar-fill group-bar-fill" v-bind:style="{
                              width: barWidth(n, i, j, metric.scoring.from, metric.scoring.to) + '%',
                              opacity: (showAverageScores || averagesShown) ? 0.6 : 0
                            }"></div>
                          </div>

                          <!-- 'backgroundColor': bagColor(coffee.bag), -->
                          <div class="rating-bar my-rating">
                              <vue-slider v-if="loaded && myScores[n]" :width="'100%'"
                                :max="metric.scoring.to"
                                :min="metric.scoring.from"
                                :interval="metric.scoring.increment"
                                :style="{
                                  'height': '12px',
                                  'padding': 0
                                }"
                                :railStyle="{
                                  'height': '12px',
                                  'borderRadius': 0,
                                  'backgroundColor': 'transparent'
                                }"
                                :stepStyle="{
                                  'display': 'flex',
                                  'backgroundColor': '#cacaca',
                                  'borderRadius': 0,
                                  'boxShadow': 'none',
                                  'width': '1px'
                                }"
                                :processStyle="{
                                  'backgroundColor': '#A3A3F5',
                                  'boxShadow': '#eeeeee',
                                  'borderRadius': 0,
                                }"
                                :tooltipStyle="{
                                  borderRadius: '12px',
                                  height: '24px',
                                  width: '24px',
                                  padding: 0,
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',

                                  'backgroundColor': (colorMode) ? bagColor2(n) : 'rgba(0,0,0,1)',
                                  
                                  'borderColor': (colorMode) ? bagColor2(n) : 'rgba(0,0,0,1)',
                                  color: colorModeOption ? '#444' : '#ddd'
                                }"
                                :dotOptions="{
                                  tooltip: 'always'
                                }"
                                :dotStyle="{
                                  display: 'none',
                                  'borderRadius': 0,
                                  'boxShadow': 'transparent',
                                  'backgroundColor': 'transparent',
                                  'borderColor': 'transparent',
                                  'backgroundSize': 'contain',
                                  'backgroundRepeat': 'no-repeat',
                                  'backgroundPosition': 'center',
                                  'height': '50px',
                                  'width': '50px',
                                  'top': '0',
                                  'transform': 'translate(-17.5px, -65px)',
                                }"
                                :marks="staticMarksObject"
                                v-model="myScores[n].steps[i].metrics[j].score"
                                @change="testf($event, metric.scoring.from, metric.scoring.to, n, i, j)" />
                          </div>
                                <!-- {{myScores[n] && myScores[n].steps[i].metrics[j].score}} -->
                            <!-- <div class="bar-fill my-bar-fill" v-bind:style="{
                            width: Math.random()*100 + '%'
                          }"></div> -->

                          <!-- <div class="df jcsb w100p aic">
                            <a v-for="(score, j) in scoreCard">{{score}}</a>
                          </div> -->
                        </div>
                        <div class="increment increment-up"  @click="changeScoreValue(0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                          <p>
                            +
                          </p>
                        </div>
                      </div>
                    </div> 

                  </div>
                  <!-- {{myScores}}     -->
                  <!-- <input v-if="metric.scoring.scoreBox && ((showSteps.indexOf(i) > -1) || !showHorizontalView)" v-model="myScores[n].steps[i].metrics[j].score" class="metric-input" type="number" @input="checkInput($event, metric.scoring.from, metric.scoring.to, [n, i, j])" name="" :step="metric.scoring.increment" :min="metric.scoring.from" :max="metric.scoring.to"> -->



                </div>

                <div v-if="polarizationShown" class="one-score-metric one-score-metric-color one-score-metric-name df fdr w100p">
                    <!-- Metric Name -->
                    <div class="one-score-title metric-title-name w100p df aic jcc">
                      <p>
                        {{polarizationsByCoffee && (Math.round(polarizationsByCoffee[n]))}}%
                      </p>
                    </div> 
                </div>
                <!-- End of Step's Metrics -->




                <div class="one-score-metric-color descriptors df fdc" v-if="groupDescriptorsShown && showSteps.indexOf(i) > -1">
                  <div class="space"></div>
                  <div class="word-cloud-wrap df fdc">
                    <div class="word-cloud df aic jcc">
                      <vue-word-cloud
                          style="
                            height: 100px;
                            width: 100%;
                            text-transform: capitalize;
                          "
                          :words="descriptorsArray[n]"
                          :color="'Grey'"
                          font-family="Inter"
                        />
                    </div>
                  </div>
                </div>
                <div class="one-score-metric-color descriptors df fdc f1" v-if="showSteps.indexOf(i) > -1">


                  <form @submit="addADescriptor($event, n)" :id="'coffee-' + n" class="descriptors-wrap">
                    <div class="descriptor-list df aic jcc">
                      <!-- <h5>My Descriptors</h5> -->
                      <div class="df fww jcc">
                        <p v-for="(descriptor, i) in myDescriptors[n]" v-bind:class="{
                          'descriptor-x-locked': ((!scoringLocked && scoringStartedF()) || onCurrentCupping()) && scoringAllowed()
                        }">
                          {{descriptor}}
                          <img v-if="((!scoringLocked && scoringStartedF()) || onCurrentCupping())" @click="removeDescriptor($event, n, i)" class="delete-descriptor curp" src="../../static/images/circle-plus.svg">
                        </p>
                      </div>
                    </div>
                    <div v-if="((!scoringLocked && scoringStartedF()) || onCurrentCupping()) && scoringAllowed()" class="df f100p jcsb aic descriptors-add">
                      <input placeholder="Add a descriptor" v-model="newDescriptors[n]" class="add-descriptor-input f1" type="text"/>
                      <button v-if="loaders['addingDescriptors']" @click="stopProp($event)" class="add-descriptor-button spinning-button"/></button>
                      <button v-else class="add-descriptor-button"/></button>
                    </div>
                  </form>
                </div>



              </div>
            </div>
          </div>

          <!-- /// -->
        </slide>
      <!-- </VueSlickCarousel> -->
      </carousel>  
      <!-- ///// -->







    </div>

    <!-- ASK A QUESTION -->
    <!-- <div id="container"></div> -->

  </div>
</template>

<script>

import router from '@/router'
import tasting_templates from '@/util/tasting_templates'
import { firebase } from '@/util/firebase'
import { firebaseInstance } from '@/util/firebase'
import _ from 'lodash'
import common from '@/util/common'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import { Carousel, Slide } from 'vue-carousel';

import $ from 'jquery'
import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.css';
// optional style for arrows & dots
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

// let generateScores = (template) => {
//   let _myScores = {}
// }

// let currentTemplate = tasting_templates['sca1']
// let myScores = generateScores(tasting_templates)

// import FlavorWheel from '@/components/FlavorWheel'
import VueWordCloud from 'vuewordcloud';

export default {
  name: 'Live',
  data () {
    return {
      tasting_templates: tasting_templates,
      enableBlindCupping: false,
      productFullDetails: {},
      parts: null,
      viewersCount: 0,
      nextLabel: `<i class="custom-nav nav-next fad fa-chevron-circle-right">`,
      prevLabel: `<i class="custom-nav nav-prev fad fa-chevron-circle-left">`,
      showFullNewMessageInput: false,
      showFullReplyInput: false,
      slidesPerRow: 1,
      weights: {'0-0': 0, '0-1': 0, '0-2': 0, '0-3': 0, '0-4': 0},
      averages: {},
      averageCounts: {},
      newQuestion: '',
      newReply: '',
      answerToQuestion: '',
      ownerId: '',
      heading: '',
      description: '',
      productImageUrl: '',
      youtubeVideoUrl: '',
      enableChat: false,
      enableVideo: false,
      productId: '',
      uniqueProductId: '',
      options: {}, // selectedTemplate, selectedTemplateData
      allowAnonymousVoting: '',
      allowAnonymousViewing: '',
      liveQuestions: {},
      replyToQuestion: '',

      youtubeVideoID: '',
      descriptorsArray: [],
      myDescriptors: [],
      newDescriptors: [],
      numberOfUsers: 0,

      colorMode: false,
      colorModeOption: 0,
      polarizationsByCoffee: {},

      revealed: false,
      scoringStarted: false,
      scoringEnded: false,
      scoringLocked: false,
      averagesShown: false,
      groupDescriptorsShown: false,
      polarizationShown: false,
      allowViewerAverageControl: false,
      showAverageScores: false,
      showHorizontalView: false,
      scoringMode: 'vertical',
      loaded: false,
      test: 7,
      loading: false,
      currentStep: 0,
      showSteps: [
        0
      ],
      coffees: [],
      currentSlide: 0,
      tastingTemplate: [],
      myScores: [],
      staticMarksObject: this.marksObject(7, 10),
      askingQuestion: false,
      replyingToQuestion: false,
      sessionStartDate: false,
      startsAt: false,
      passwordScoring: false,
      passwordEntered: false,
      passwordActivated: false,
      passwordError: false,
      showDescription: false,
      loaders: {},
      spl: '',
      averageSpread: {},
      editingField: false,
      editingCoffee: false,

      showMoreNewCoffeeOptions: false,

      addNewCoffeeInput: '', 
      addNewCoffeeImageUrl: '', 
      addNewCoffeeBuyNowLink: '', 
      addNewCoffeeValidationError: '', 
      showAddNewCoffeePopup: false,
      addNewCoffeeType: 'New',
      // templates: templates
      // productImageUrl: '',

      dropzoneOptions: {
          autoProcessQueue: false,
          url: 'https://',
          thumbnailWidth: 150,
          maxFilesize: 1,
          // headers: { "My-Awesome-Header": "header value" },
          // dictDefaultMessage: 'Check',
          // previewTemplate: document.querySelector('#template-container').innerHTML
          dictDefaultMessage: ``
      },

    }
  },
  props: ['mode'],
  components: {
    VueSlider,
    VueSlickCarousel,
    // FlavorWheel,
    [VueWordCloud.name]: VueWordCloud,
    Carousel,
    Slide,
    vueDropzone: vue2Dropzone
  },
  methods: {
    showAddCoffee () {
      // showAddNewCoffee (i) {
        // console.log('show', i)
      this.showAddNewCoffeePopup = 'New'
      document.body.className = 'popup-shown';
        // this.populateExistingCoffee()
      // },
    },
    removeCoffeeFromTastingSession (index) {
      let coffees = this.coffees
      coffees.splice(index, 1)

      // delete from /live..._...coffees somewhere
      // delete scores

      this.coffees = coffees
      this.saveProduct()
      this.showAddNewCoffeePopup =  false
    },
    goTo (path, event) {
      event && event.stopPropagation()
      router.push(path)
    },
    onCurrentCupping () {
      return this.$route.params.liveSessionId === this.$store.getters['AUTH.myCurrentCupping']
    },
    uploadedProductImage (file) {
      let item = {
        productId: this.productId,
        file
      }
      this.$store.dispatch('AUTH.uploadProductImage', item).then((res) => {
        console.log('res', res.url)
        this.addNewCoffeeImageUrl = res.url
      })
    },
    clearAddCoffeeForm () {
      this.showMoreNewCoffeeOptions = false
      this.addNewCoffeeType = 'New'
      this.addNewCoffeeInput = ''
      this.addNewCoffeeImageUrl = ''
      this.addNewCoffeeBuyNowLink = ''
      this.addExistingCoffeeValidationError = ''
      this.productImageUrl = ''
    },
    selectCoffeeType (type) {
      console.log('type', type)
      if (type == 'Existing') {
        this.showMoreNewCoffeeOptions = false
      } else if (type == 'New') {
        this.showMoreExistingCoffeeOptions = false
      }
      this.addNewCoffeeType = type
    },
    setShowMoreNewCoffeeOptions (v) {
      this.showMoreNewCoffeeOptions = v
    },
    hideAddCoffeePopup () {
      // if (this.showAddNewCoffeePopup) {
      this.showAddNewCoffeePopup = false
      document.body.className = '';
      this.clearAddCoffeeForm()
      // }
    },
    showAddNewCoffee (i) {
      console.log('show', i)
      this.showAddNewCoffeePopup = i
      document.body.className = 'popup-shown';
      this.populateExistingCoffee()
    },
    populateExistingCoffee () {
      if (this.$store.getters['AUTH.uid']) {
        let coffees = this.coffees
        let coffee = coffees[this.showAddNewCoffeePopup]

        if (coffee) {
          this.addNewCoffeeBuyNowLink = coffee.buyNowLink
          this.addNewCoffeeImageUrl = coffee.imageUrl
          this.addNewCoffeeInput = coffee.name
        }
      }
    },
    editField (field) {
      this.editingField = field
    },

    saveProduct (activate) {
      let productObject = {
        heading: this.heading,
        description: this.description,
        productImageUrl: this.productImageUrl,
        youtubeVideoUrl: this.youtubeVideoUrl,
        enableChat: this.enableChat,
        enableVideo: this.enableVideo,
        passwordScoring: this.passwordScoring,
        spl: this.spl,
        uniqueProductId: this.uniqueProductId,
        scoringLocked: true,
        scoringStarted: false,
        productId: this.productId,
        options: {
          coffees: this.coffees,
          selectedTemplate: this.options.selectedTemplate,
          selectedTemplateData: this.tasting_templates[this.options.selectedTemplate],
          enableBlindCupping: this.enableBlindCupping,
          allowViewerAverageControl: this.allowViewerAverageControl, 
          allowAnonymousVoting: this.allowAnonymousVoting,
          allowAnonymousViewing: this.allowAnonymousViewing,
          colorMode: this.colorMode,
          colorModeOption: this.colorModeOption,
        },
      }
        console.log('saveProduct 1', productObject)
      // validation
      if (!productObject.heading) {
        console.log('1')
        this.saveLiveTastingError = '* Please give the session a name.'
      } else if (productObject.options.coffees.length == 0) {
        console.log('2')
        this.saveLiveTastingError = '* Please select coffees for tasting.'
      } else if (!productObject.options.selectedTemplate) {
        console.log('3')
        this.saveLiveTastingError = '* Please select a tasting template.'
      } else {
        console.log('4')
        this.saveLiveTastingError = false
        if (activate) {
          productObject.public = true
        }
        console.log('saveProduct 2', productObject)
        this.$store.dispatch('AUTH.saveLiveTastingProduct', productObject).then((res) => {
          console.log('*!')
          let product = res
          for (let i in product) {
            this[i] = product[i]
          }

        })
      }

    },
    updateSessionDetail (which, newValueEvent) {
      console.log('updateSessionDetail', which, newValueEvent.target.value)

      // // 'heading'
      if (which == 'heading') {
        this.heading = newValueEvent.target.value
        this.saveProduct()
      }

      this.editingField = false
    },
    saveCoffee () {
      if (this.$store.getters['AUTH.uid']) {
        let coffees = this.coffees
        let coffeeObject = {}

        // check new of existing selected
        
        let run = async () => {
          console.log('run')
          console.log(this.addNewCoffeeType)
          if (this.addNewCoffeeType == 'New') {
            coffeeObject = {
              blindTastingId: this.addNewCoffeeBlindTastingIdentifier,
              name: this.addNewCoffeeInput,
              imageUrl: this.addNewCoffeeImageUrl,
              buyNowLink: this.addNewCoffeeBuyNowLink,
              // bag: 'blue' // ?
            }
            // validate
            console.log('coffeeObject', coffeeObject)
            if (coffeeObject.name) {
              // // create coffee in my coffees
              // var addedCoffee = firebase.functions().httpsCallable('addNewCoffee')
              // let p = await addedCoffee(coffeeObject)

              coffees.push(coffeeObject)
              this.coffees = coffees

              this.clearAddCoffeeForm()

              this.showAddNewCoffeePopup = false
              document.body.className = ''
            }

            this.saveProduct()
            // router.go()
          // this.showAddNewCoffeePopup =  false

          } else {
            this.saveProduct()
          }
        }

        run()
      }
    },
    editCoffee (coffee, field) {
      this.showAddNewCoffee(coffee)
      // this.showAddNewCoffeePopup = 
      // this.editingCoffee = [coffee, field]
    },
    updateCoffeeDetail (coffee, which, newValueEvent) {
      console.log('updateCoffeeDetail', coffee, which, newValueEvent.target.value)
      this.editingCoffee = false
    },
    formatDate (d) {
      return common.formatDate3(d)
    },
    submitDescriptor (n, event) {
      event.preventDefault()
      document.getElementById('coffee-' + n).submit()
    },
    popupDescription (v) {
      this.showDescription = v
    },
    scoringAllowed () {
      // console.log('HOST?', this.host())
      if (this.host()) {
        return true
      }

      // if (invited) { //
      //   return true
      // }

      let needPassword = this.passwordScoring
      let password = this.$route.query.spl || 'no'

      if (needPassword) {
        if (password == this.spl) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    scoringStartedF () {
      return this.scoringStarted
      // let now = (new Date()).getTime()
      // if (now < 1644791144698) { // v0.1 release
      //   console.log('now', this.scoringStarted)
      // } else {
      //   return true
      // }
    },
    trashComment (i) {
      let go = confirm('Are you sure you want to permanently hide this comment? This cannot be undone. All replies will be hidden.')
      if (go) {
        this.$store.dispatch('AUTH.trashComment', {
          session: this.uniqueProductId,
          questionId: i
        }).then((res) => {
          if (res == 'ok') {
            //
          }
        })
      }
    },
    trashReply (i, commentId) {
      let go = confirm('Are you sure you want to permanently hide this reply? This cannot be undone.')
      if (go) {
        this.$store.dispatch('AUTH.trashReply', {
          session: this.uniqueProductId,
          questionId: i,
          commentId
        }).then((res) => {
          if (res == 'ok') {
            //
          }
        })
      }
    },
    deleteComment (i) {
      let go = confirm('Are you sure you want to delete this comment?')
      if (go) {
        this.$store.dispatch('AUTH.deleteComment', {
          session: this.uniqueProductId,
          questionId: i
        }).then((res) => {
          if (res == 'ok') {
            //
          }
        })
      }
    },
    deleteReply (i, commentId) {
      let go = confirm('Are you sure you want to delete this reply?')
      if (go) {
        this.$store.dispatch('AUTH.deleteReply', {
          session: this.uniqueProductId,
          questionId: i,
          commentId
        }).then((res) => {
          if (res == 'ok') {
            //
          }
        })
      }
    },
    templateScore (template) {
      return common.templateScore(template)
    },
    getNextPage() {
      if (this.currentSlide + this.slidesPerRow < this.coffees.length) {
        return this.currentSlide + this.slidesPerRow;
      }
      return 0
    },
    getPreviousPage() {
      if (this.currentSlide > 0) {
        return this.currentSlide - 1;
      }
      return this.coffees.length - 1
    },

    prevSlide () {
      this.currentSlide = this.getPreviousPage()
    },
    nextSlide () {
      this.currentSlide = this.getNextPage()
    },
    slideChange (slide) {
      this.currentSlide = slide
    },
    onUnFocusNewMessage () {
      this.showFullNewMessageInput = false
    },
    onFocusNewMessage () {
      this.showFullNewMessageInput = true
    },
    onFocusNewReply () {
      this.showFullReplyInput = true
    },
    onUnFocusNewReply () {
      this.replyToQuestion = false
      this.showFullReplyInput = false
    },
    setShowAverageScores (val) {
      this.showAverageScores = val
    },
    hideCuppingSettingsPopup () {
      this.$store.dispatch('AUTH.showCuppingSettings', false)
    },
    stopProp (e) {
      e.stopPropagation()
    },
    addADescriptor (e, n) {
      e.preventDefault()
      let newDescriptor = this.newDescriptors[n]
      let myDescriptors = this.myDescriptors

      if (newDescriptor == '') {
        return false
      }

      console.log('***** starting descriptors', myDescriptors, newDescriptor)
      let oneDescriptor = myDescriptors[n] || []
      oneDescriptor.push(newDescriptor)
      myDescriptors[n] = oneDescriptor
      this.loaders['addingDescriptors'] = true
      this.$store.dispatch('AUTH.updateMyDescriptors', {uniqueProductId: this.uniqueProductId, n, myDescriptors}).then((res) => {
        if (res == 'ok') {
          this.newDescriptors[n] = ''
        }
      })
    },
    removeDescriptor (e, n, i) {
      e.preventDefault()
      let myDescriptors = this.myDescriptors
      myDescriptors[n].splice(i, 1)
      this.$store.dispatch('AUTH.updateMyDescriptors', {uniqueProductId: this.uniqueProductId, n, myDescriptors}).then((res) => {
        if (res == 'ok') {
          // this.newDescriptors[n] = ''
        }
      })
    },
    pushRevealCoffees (tf) {
      let uniqueProductId = this.uniqueProductId
      this.$store.dispatch('AUTH.pushRevealCoffees', {tf, uniqueProductId}) 
    },
    pushShowAverageScores (tf) {
      let uniqueProductId = this.uniqueProductId
      this.$store.dispatch('AUTH.pushShowAverageScores', {tf, uniqueProductId}) 
    },
    pushShowGroupDescriptors (tf) {
      let uniqueProductId = this.uniqueProductId
      this.$store.dispatch('AUTH.pushShowGroupDescriptors', {tf, uniqueProductId}) 
    },
    pushShowPolarization (tf) {
      let uniqueProductId = this.uniqueProductId
      this.$store.dispatch('AUTH.pushShowPolarization', {tf, uniqueProductId}) 
    },
    pushLockScoring (tf) {
      let uniqueProductId = this.uniqueProductId
      this.$store.dispatch('AUTH.pushLockScoring', {tf, uniqueProductId}) 
    },
    endSession (tf) {
      let uniqueProductId = this.uniqueProductId
      let goAhead = confirm('End the session now?')
      if (goAhead) {
        this.$store.dispatch('AUTH.endSession', {tf, uniqueProductId}) 
      }
    },
    pushLockScoringStart (tf) {
      let uniqueProductId = this.uniqueProductId
      let goAhead = confirm('Start the session now?')
      if (goAhead) {
        this.$store.dispatch('AUTH.pushLockScoringStart', {tf, uniqueProductId}) 
      }
    },
    barWidth (n, i, j, from, to) {
      let averages = this.averages
      if (averages[n]) {
        if (averages[n][i]) {
          if (averages[n][i][j]) {
            if (averages[n][i][j]) {
              let from = this.tastingTemplate.steps[i].metrics[j].scoring.from
              let to = this.tastingTemplate.steps[i].metrics[j].scoring.to
              return 100*(averages[n][i][j] - from)/(to-from) 
            }
          }
        }
      }
      return '0'
    },
    testf (e, min, max, n, i, j) {
      let val = e
      this.checkInput({target: {value: e}}, min, max, [n, i, j])
    },
    polarizationOfCoffee (i) {
      let coffee = this.coffees[i]
      // console.log('coffee', coffee)

      let averages = this.averages
      // let allScores = 

      let steps = 0
      let deviation = 0

      // for each step
        // for each metric
          // let range = max - min
          // get average for metric (this should be calculated on change)
          // for each score result
            // let _d = score - average
            // let d = Math.abs(_d/range)
            // deviation += d
            // steps += 1

    },
    startReplyToQuestion (i) {
      this.replyToQuestion = i
      let existingReply = this.liveQuestions[i].reply
      if (existingReply) {
        this.answerToQuestion = existingReply
      }
      setTimeout(() => {
        let field = document.getElementById('your-reply')
        field.focus()
      }, 300)
    },
    endReplyToQuestion () {
      this.replyToQuestion = ''
    },
    answerReplyToQuestion (replyingToQuestion) {
      if (this.replyingToQuestion) {
        return false
      }
      this.replyingToQuestion = true
      let i = this.replyToQuestion
      let reply = this.newReply
      this.$store.dispatch('AUTH.replyToQuestion', {
        session: this.uniqueProductId,
        questionId: i,
        reply
      }).then((res) => {
        this.replyingToQuestion = false
        if (res == 'ok') {
          this.newReply = ''
          this.replyToQuestion = ''
          this.answerToQuestion = ''
        }
      }).catch((e) => {
        this.replyingToQuestion = false
      })
    },
    askAQuestion (askingQuestion) {
      if (askingQuestion) {
        return false
      }
      this.askingQuestion = true
      this.$store.dispatch('AUTH.askAQuestion', {
        uid: this.$store.getters['AUTH.uid'],
        name: this.$store.getters['AUTH.myPublicData'].displayName || null,
        location: this.$store.getters['AUTH.myLocation'] || null,
        session: this.uniqueProductId,
        question: this.newQuestion
      }).then((res) => {
        this.newQuestion = ''
        this.showFullNewMessageInput = false
        this.askingQuestion = false

        let el = document.getElementById('live-qupping-questions-list')
        el.scrollTop = -el.offsetHeight
      }).catch((e) => {
        this.askingQuestion = false
      })
    },
    plusOneAQuestion (i) {
      this.$store.dispatch('AUTH.plusOneAQuestion', {
        session: this.uniqueProductId,
        question: i
      }).then((res) => {
        // this.newQuestion = ''
      })
    },
    markAsQuestion (i) {
      this.$store.dispatch('AUTH.markAsQuestion', {
        session: this.uniqueProductId,
        question: i
      }).then((res) => {
        // this.newQuestion = ''
      })
    },
    host () {
      return !this.ownerId ? false : this.$store.getters['AUTH.uid'] == this.ownerId
    },
    flipColorMode () {
      this.$store.dispatch('AUTH.flipColorMode', {})
    },
    small () {
      let width = window.innerWidth
      return width < 1000
    },
    smaller () {
      let width = window.innerWidth
      console.log('width', width)
      return width < 610
    },
    videoHeight () {
      let height = window.innerHeight
      let width = window.innerWidth

      if (width < 1000) {
        return height / 3
      }

      return height / 2
    },
    videoWidth () {
      let height = window.innerHeight
      let width = window.innerWidth
      if (width < 1000) {
        return width - 45
      }
      return this.videoHeight()*1.5
    },
    marksObject (from, to) {
      console.log('MAKING MARKS OBJECT')
      let interval = 0.25
      let object = {}
      for (let i = from; to - i >= 0; i = i + interval) {
        let height1 = 24;
        let height2 = 16;
        let height3 = 8;

        let display = 'none';

        let height = height3;
        if ((i % (interval * 4)) == 0) {
          height = height1
          display = 'block';
        } else if ((i % (interval * 2)) == 0) {
          height = height2
        }
        let translate = 12 + height * -1



        object[i] = {
          style: {
            width: '1px',
            height: height + 'px',
            display: 'block',
            backgroundColor: '#5c5c5c',
            transform: 'translate(2px,' + translate + 'px)'
          },
          labelStyle: {
            marginTop: '5px',
            color: 'grey',
            display: display
          }
        }
      }
      return object
    },
    myScoresSheet (template) { // ,,,
      let sheet = [] //
      let coffees = this.coffees
      console.log('myScoresSheet myScoresSheet', coffees)
      for (let n in coffees) {
        let coffee = {steps: []}
        for (let i in template.steps) {
          let step = {metrics: []}
          for (let j in template.steps[i].metrics) {
            let metric = {score: null}
            // let metric = {score: template.steps[i].metrics[j].from}
            step.metrics.push(metric)
          }
          coffee.steps.push(step)
        }
        sheet.push(coffee)
      }
      console.log('scores', sheet)
      return sheet
    },
    metricScore (n, i, j) {
      let tastingTemplate = this.tastingTemplate
      if (tastingTemplate.steps[i]) {
        if (tastingTemplate.steps[i].metrics[j]) {
          if (tastingTemplate.steps[i].metrics[j].score) {
            if (tastingTemplate.steps[i].metrics[j].score[n]) {
              return tastingTemplate.steps[i].metrics[j].score[n]
            }
          }
        }
      }
      return null
    },
    averageCoffeeScore (n) {
      // console.log('averages', this.averages)
      let averages = this.averages
      let averageCounts = this.averageCounts
      let scores = averages[n]
      let scoresCounts = averageCounts[n]
      let total = 0
      for (let category in scores) {
        for (let metric in scores[category]) {
          let weight = this.weights[category + '-' + metric]
          let score = scores[category][metric]
          let count = scoresCounts[category][metric]
          if (score) {
            let add = weight * score
            total = total + add
          } else {
            // console.log('this.tastingTemplate', score, scores)
          }
        }
      }
      return total.toFixed(1)
    },
    coffeeScore (n) {
      let myScores = this.myScores
      let totalScore = 0

      if (this.tastingTemplate.addToScore) {
        totalScore += parseInt(this.tastingTemplate.addToScore)
      }

      if (myScores[n]) {
        for (let i in myScores[n].steps) {
          for (let j in myScores[n].steps[i].metrics) {
            if (myScores[n].steps[i].metrics[j].score) {
                let score = myScores[n].steps[i].metrics[j].score
                let metricTypeScoring = this.tastingTemplate.steps[i].metrics[j].scoring
                if (metricTypeScoring.type == 'number-magnitude-k') {
                  // console.log('score', score.number)
                  let k = metricTypeScoring.k
                  let addToScore = (score.number || 0) * (score.magnitude || 0) * k
                  totalScore = totalScore + addToScore * (this.weights[i.toString() + '-' + j.toString()] || 0)
                } else if (metricTypeScoring.type == 'check-x-times-k') {
                  for (let z in score) {
                    totalScore = totalScore + score[z] * (this.weights[i.toString() + '-' + j.toString()] || 0)
                  }
                } else {
                  totalScore = totalScore + score * (this.weights[i.toString() + '-' + j.toString()] || 0)
                }
            }
          }
        }
      }

      // console.log('totalScore', totalScore)

      return totalScore.toFixed(1)
    },
    randomWordList () {
      let array = []
      let words = [
        'acidity',
        'aftertaste',
        'body',
        'aroma',
        'flavor',
        'region',
        'orange',
        'peach',
        'bergamot',
        'berry',
      ]
      let max = words.length
      let randomLength = Math.floor(max * Math.random())
      for (let i = 0; i < randomLength; i = i + 1) {
        let randomWord = Math.floor(max * Math.random())
        randomWord = words[randomWord]
        let randomNumber = Math.ceil(Math.random() * 20)
        array.push([
          randomWord,
          randomNumber
        ])
      }
      return array
      // [['romance', 19], ['horror', 3], ['fantasy', 7], ['adventure', 3]]
    },
    setCheckInput (n, i, j, z, val) {
      console.log('setCheckInput', n, i, j, z, val)
      // submit my score
      let newScore = {
        n, i, j, val: {[z]: val},
        session: this.uniqueProductId
      }
      this.$store.dispatch('AUTH.setNewScore', newScore)
      // let tastingTemplate = this.tastingTemplate
      // myScores[n].steps[i].metrics[j].score
      // tastingTemplate.steps[i].metrics[j].score[n]
    },
    setCurrentStep (i) {
      this.currentStep = i
    },
    changeScoreValue(amount, min, max, coords) {
      let n = coords[0]
      let i = coords[1]
      let j = coords[2]
      let currentScore = this.myScores[n].steps[i].metrics[j].score || 0
      let newScore = currentScore + amount
      newScore = Math.round(newScore * 10) / 10
      let event = {target: {value: newScore}}
      this.checkInput(event, min, max, coords)
    },
    checkInput: _.debounce(function(event, min, max, coords, subScore) {
      let val = event.target.value
      let n = coords[0]
      let i = coords[1]
      let j = coords[2]

      console.log('==>', val, min, max, coords, subScore)

      let _val = null
      if (val == '') {
        this.myScores[n].steps[i].metrics[j].score = (subScore ? {[subScore]: null} : null)
      } else if (val < min) {
        this.myScores[n].steps[i].metrics[j].score = (subScore ? {[subScore]: min} : min)
        _val = min
      } else if (val >= max) {
        this.myScores[n].steps[i].metrics[j].score = (subScore ? {[subScore]: max} : max)
        _val = max
      } else {
        if (this.myScores[n]) {
          if (this.myScores[n].steps[i]) {
            if (this.myScores[n].steps[i].metrics[j]) {
              this.myScores[n].steps[i].metrics[j].score = (subScore ? {[subScore]: val} : val)               
            } else {
              this.myScores[n].steps[i].metrics[j] = {score: (subScore ? {[subScore]: val} : val)}
            }
          } else {
            this.myScores[n].steps[i] = {metrics: {[j]: {score: (subScore ? {[subScore]: val} : val)}}}
          }
        } else {
          this.myScores[n] = {steps: {[i]: {metrics: {[j]: {score: (subScore ? {[subScore]: val} : val)}}}}}
        }
        
        _val = val
      }
      // submit my score
      let newScore = {
        n, i, j, val: (subScore ? {[subScore]: _val} : _val),
        session: this.uniqueProductId
      }
      this.$store.dispatch('AUTH.setNewScore', newScore)

    }, 500),
    toggleShowStep (i) {
      if (this.showSteps.indexOf(i) > -1) {
        let showSteps = this.showSteps
        let index = showSteps.indexOf(i)
        showSteps.splice(index, 1)
        this.showSteps = showSteps
      } else {
        let showSteps = this.showSteps
        showSteps.push(i)
        this.showSteps = showSteps
      }
    },
    bagColor2 (n) {
      let c = n % 4 + 1
      switch(c) {
        case 1:
          return '#000'
          break;
        case 2:
          return '#E93333'
          break;
        case 3:
          return '#28C1EA'
          break;
        case 4:
          return '#9F31E3'
          break;
        default:
          return '#ddd'
      }
    },
    bagColor (name) {
      switch(name) {
        case 'blue':
          return '#0366bf'
          break;
        case 'green':
          return '#01886a'
          break;
        case 'yellow':
          return '#f7c132'
          break;
        case 'orange':
          return '#fc642c'
          break;
        default:
          return '#ddd' 
          // code block
      }
    },
    revealRefresh () {
      let uniqueProductId = this.uniqueProductId
      let uid = this.$store.getters['AUTH.uid']
      firebaseInstance.database().ref('publicLiveCuppings_Scores/' + uniqueProductId + '/scores/' + uid).off('value')
      firebaseInstance.database().ref('publicLiveCuppings_Scores/' + uniqueProductId).off('value')
      firebaseInstance.database().ref('publicLiveCuppings_Descriptors/' + uniqueProductId + '/descriptors/' + uid).off('value')
      firebaseInstance.database().ref('publicLiveCuppings_Descriptors/' + uniqueProductId).off('value')
      firebaseInstance.database().ref('publicLiveCuppings_Messages/' + uniqueProductId).off('value')

      console.log('revealRefresh')

      this.watchProductData()
    },
    watchPings () {
      let uid = this.$store.getters['AUTH.uid']
      if (uid) {
        firebaseInstance.database().ref('/pings/' + uid).on('value', (snap) => {
          let pings = snap.val()
        })
      } else {
        setTimeout(() => {
          this.watchPings()
        })
      }
    },
    watchProductData () {
      let run = async () => {
        // let user = firebaseInstance.auth().currentUser
        // console.log('user', user.,)
        // if (this.$store.getters['AUTH.uid']) {
        if (this.$store.getters['AUTH.uid']) {

          let public_products_path = 'publicLiveCuppings_Main/'

          let route = this.$route
          let productId = route.params.liveSessionId

          let uid = this.$store.getters['AUTH.uid']
          let productDetailsRef = public_products_path + productId
          let _productDetails = await firebaseInstance.database().ref(productDetailsRef).once('value')
          let productDetails = _productDetails.val()
          let uniqueProductId = productDetails.uniqueProductId
          let productFullDetailsRef = public_products_path + uniqueProductId
          console.log('path', 'publicLiveCuppings_Coffees/' + uniqueProductId)


          console.log('GET THE COFFEES', 'publicLiveCuppings_Coffees/' + uniqueProductId)



          let getAllScores = () => {

            // scores - all
            firebaseInstance.database().ref('publicLiveCuppings_Scores/' + uniqueProductId).on('value', async (snap) => {
              let productFullDetails = snap.val()
              let product = productFullDetails || {}
              let uid = this.$store.getters['AUTH.uid']
              let average = this.averages

              console.log('ALL SCORES****', this.tastingTemplate.length, product)

              if (this.myScores.length == 0) {
                console.log('here')
                this.tastingTemplate = product.options ? product.options.selectedTemplateData : false
                this.myScores = this.myScoresSheet(this.tastingTemplate)              
              }
                console.log('product2', product)

              let scores
              scores = this.myScores

              // this.averagesShown = product.averagesShown
              // this.groupDescriptorsShown = product.groupDescriptorsShown
              // this.polarizationShown = product.polarizationShown

              this.numberOfUsers = Object.keys(product.scores || {}).length



              // console.log('myScores1', this.tastingTemplate)
              // console.log('myScores2', this.myScores)
              // console.log('averages', this.averages)
              let newScores = {}
              if (product.scores && product.scores[uid]) {
                newScores = product.scores[uid].coffees
              }
              for (let n in newScores) {
                let steps = newScores[n].steps
                // console.log('steps', steps)
                for (let i in steps) {
                  let step = steps[i]
                  for (let j in step.metrics) {
                    if (newScores[n] &&
                        newScores[n].steps[i] &&
                        newScores[n].steps[i].metrics[j] &&
                        newScores[n].steps[i].metrics[j].score) {
                    let score = newScores[n].steps[i].metrics[j].score
                      if (scores[n]) {
                        if (scores[n].steps[i].metrics) {
                          if (scores[n].steps[i].metrics[j]) {
                            scores[n].steps[i].metrics[j].score = score
                          } else {
                            scores[n].steps[i].metrics[j] = {score: score}
                          }
                        } else {
                          scores[n].steps[i].metrics = {[j]: {score: score}}
                        }
                      } else {
                        scores[n] = {steps: {[i]: {metrics: {[j]: {score: score}}}}}
                      }
                    }
                  }
                }
              }

              // get averages per metric
              let metricNumbers = {}
              let metricTotals = {}

              let bars = 10
              let metricSpreadNumbers = {}
              let metricSpreadTotals = {}

              for (let _uid in product.scores) {
                let newScores = product.scores[_uid].coffees
                for (let n in newScores) {
                  let steps = newScores[n].steps
                  // console.log('steps', steps)
                  for (let i in steps) {
                    let step = steps[i]
                    for (let j in step.metrics) {
                      let metric = step.metrics[j]
                      if (!metricNumbers[n]) {
                        metricNumbers[n] = {[i]: {}}
                      }
                      if (!metricNumbers[n][i]) {
                        metricNumbers[n][i] = {}
                      }
                      if (!metricTotals[n]) {
                        metricTotals[n] = {[i]: {}}
                      }
                      if (!metricTotals[n][i]) {
                        metricTotals[n][i] = {}
                      }

                      // if (!metricSpreadNumbers[n]) {
                      //   metricSpreadNumbers[n] = {[i]: {}}
                      // }
                      // if (!metricSpreadNumbers[n][i]) {
                      //   metricSpreadNumbers[n][i] = {}
                      // }
                      if (!metricSpreadTotals[n]) {
                        metricSpreadTotals[n] = {[i]: {}}
                      }
                      if (!metricSpreadTotals[n][i]) {
                        metricSpreadTotals[n][i] = {}
                      }

                      // let metricTypeScoring = this.tastingTemplate.steps[i].metrics[j].scoring
                      // console.log('!!!', metricTypeScoring)
                      // if (metricTypeScoring.type == 'check-x-times-k') {
                        // for (let check in metric.score) {
                          // if (metric.score[check]) {
                            // metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + 1
                          // }
                        // }
                        // metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
                      // } else {

                        // if (!metricSpreadNumbers[n][i][j]) {
                        //   metricSpreadNumbers[n][i][j] = []
                        //   for (let k = 0; k < bars; k = k + 1) {
                        //     metricSpreadNumbers[n][i][j][k] = 0
                        //   }
                        // }
                        if (!metricSpreadTotals[n][i][j]) {
                          metricSpreadTotals[n][i][j] = []
                          for (let k = 0; k < bars; k = k + 1) {
                            metricSpreadTotals[n][i][j][k] = 0
                          }
                        }

                        let min = parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.from)
                        let max = parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.to)
                        let range = max - min             
                        let interval = range/bars

                        for (let k = 0; k < bars; k = k + 1) {
                          // console.log('metric.score', metric.score, min, range, interval)
                          if (metric.score <= min + (interval * (k + 1))) {
                            // metricSpreadNumbers[n][i][j][k] = metricSpreadNumbers[n][i][j][k] + metric.score
                            metricSpreadTotals[n][i][j][k] = metricSpreadTotals[n][i][j][k] + 1
                            break
                          }
                        }

                        // console.log('ADD SCORE', (metricNumbers[n][i][j] || 0) + metric.score)

                        metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + metric.score
                        metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
                      // }
                    }
                  }
                }
              }

              let maxHeight = 0
              let barHeight = 30

              for (let _n in metricSpreadTotals) {
                for (let _i in metricSpreadTotals[_n]) {
                  for (let _j in metricSpreadTotals[_n][_i]) {
                    for (let _k in metricSpreadTotals[_n][_i][_j]) {
                      if (metricSpreadTotals[_n][_i][_j][_k] > maxHeight) {
                        maxHeight = metricSpreadTotals[_n][_i][_j][_k]
                      }
                    }
                  }
                }
              }

              for (let _n in metricSpreadTotals) {
                for (let _i in metricSpreadTotals[_n]) {
                  for (let _j in metricSpreadTotals[_n][_i]) {
                    for (let _k in metricSpreadTotals[_n][_i][_j]) {
                        metricSpreadTotals[_n][_i][_j][_k] = metricSpreadTotals[_n][_i][_j][_k] * (barHeight / maxHeight)
                    }
                  }
                }
              }

              this.averageSpread = metricSpreadTotals
              let averages = {}
              let averageCounts = {}

              let averagesSpread = {}
              let averageCountsSpread = {}

              for (let n in metricNumbers) {
                let steps = metricNumbers[n]
                for (let i in steps) {
                  let metrics = steps[i]
                  for (let j in metrics) {
                    // 1
                    let metric = metrics[j]
                    let number = metricTotals[n][i][j]
                    let average = metric/number


                    if (!averages[n]) {
                      averages[n] = {[i]: {[j]: {}}}
                      averageCounts[n] = {[i]: {[j]: 0}}
                    }
                    if (!averages[n][i]) {
                      averages[n][i] = {[j]: {}}
                      averageCounts[n][i] = {[j]: 0}
                    }

                    // if (!averagesSpread[n]) {
                    //   averagesSpread[n] = {[i]: {[j]: {}}}
                    //   averageCountsSpread[n] = {[i]: {[j]: {}}}
                    // }
                    // if (!averagesSpread[n][i]) {
                    //   averagesSpread[n][i] = {[j]: {}}
                    //   averageCountsSpread[n][i] = {[j]: {}}
                    // }

                    let min = metric.min
                    let range = metric.max - metric.min                   
                    let interval = range/bars

                    // for (let k = 0; k < bars; k = k + 1) {
                    //   // if (metric.score <= min + (interval * (k + 1))) {
                    //   //   ,,,,
                    //   //   averagesSpread[n][i][j][k] = 0
                    //   //   averageCountsSpread[n][i][j][k] = 0
                    //   // }
                    //   let number2 = metricSpreadNumbers[n][i][j][k]
                    //   let total2 = metricSpreadTotals[n][i][j][k]
                    //   let average2 = total2 ? number2/number2 : 0

                    //   // console.log('averagesSpread', averagesSpread[n][i], j, k)

                    //   averagesSpread[n][i][j][k] = average2
                    //   averageCountsSpread[n][i][j][k] = total2
                    // }

                    averages[n][i][j] = average
                    averageCounts[n][i][j] = number                      
                  }
                }
              }
              // get polarization
              let polarizationTotal = {}
              let polarizationNumber = {}
              for (let _uid in product.scores) {
                let newScores = product.scores[_uid].coffees
                for (let n in newScores) {
                  let steps = newScores[n].steps
                  // console.log('steps', steps)
                  for (let i in steps) {
                    let step = steps[i]
                    for (let j in step.metrics) {
                      let metric = step.metrics[j]
                      let metricRange = parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.to) - parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.from)
                      // console.log('METRIC!', this.tastingTemplate.steps[i].metrics[j].scoring.from)

                      if (!polarizationNumber[n]) {
                        polarizationNumber[n] = {[i]: {}}
                      }
                      if (!polarizationNumber[n][i]) {
                        polarizationNumber[n][i] = {}
                      }
                      if (!polarizationTotal[n]) {
                        polarizationTotal[n] = {[i]: {}}
                      }
                      if (!polarizationTotal[n][i]) {
                        polarizationTotal[n][i] = {}
                      }
                      // divide by metric range
                      polarizationNumber[n][i][j] = (polarizationNumber[n][i][j] || 0) + 2*100*Math.abs(metric.score - averages[n][i][j])/metricRange
                      polarizationTotal[n][i][j] = (polarizationTotal[n][i][j] || 0) + 1
                      // let range = metric.max - metric.min                   
                    }
                  }
                }
              }
              let polarizations = {}

              for (let n in polarizationNumber) {
                let steps = polarizationNumber[n]
                for (let i in steps) {
                  let metrics = steps[i]
                  for (let j in metrics) {
                    let metric = metrics[j]
                    let number = polarizationTotal[n][i][j]
                    let average = metric/number


                    if (!polarizations[n]) {
                      polarizations[n] = {[i]: {[j]: {}}}
                    }
                    if (!polarizations[n][i]) {
                      polarizations[n][i] = {[j]: {}}
                    }
                    polarizations[n][i][j] = average

                  }
                }
              }

              let polarizationsByCoffee = {}
              let polarizationsByCoffeeNumber = {}

              for (let coffee in polarizations) {
                for (let i in polarizations[coffee]) {
                  for (let j in polarizations[coffee][i]) {
                    polarizationsByCoffee[coffee] = (polarizationsByCoffee[coffee] || 0) + polarizations[coffee][i][j]
                    polarizationsByCoffeeNumber[coffee] = (polarizationsByCoffeeNumber[coffee] || 0) + 1
                  }
                }
              }

              let polarizationsByCoffeeFinal = {}
              for (let coffee in polarizationsByCoffee) {
                polarizationsByCoffeeFinal[coffee] = polarizationsByCoffee[coffee] / polarizationsByCoffeeNumber[coffee]
              }

              this.polarizationsByCoffee = polarizationsByCoffeeFinal


              setTimeout(() =>{
                this.myScores = scores
                this.averageCounts = averageCounts
                this.averages = averages
                // console.log('test', scores, averageCounts, averages)
              }, 100)
            })
          }

          let tryForScores = () => {
            // console.log('tryForScores', this.tastingTemplate, this.coffees)
            if (this.tastingTemplate) {
              getAllScores()
            } else {
              setTimeout(() => {
                tryForScores()
              }, 500)
            }
          }


          firebaseInstance.database().ref('publicLiveCuppings_Coffees/' + uniqueProductId).on('value', (snap) => {
            console.log('GOT THE COFFEES1')
            let coffees = snap.val()
            console.log('GOT THE COFFEES2', coffees)
            this.coffees = coffees
            tryForScores()
          })

          firebaseInstance.database().ref(productFullDetailsRef).on('value', (snap) => {
            let productFullDetails = snap.val()
            let product = productFullDetails
            console.log('PRODUCT ***', product)

            this.productFullDetails = product

            for (let i in product) {
              this[i] = product[i]
            }

            let setWeights = () => {
              if (this.tastingTemplate.steps) {
                let weights = {}
                let templateSteps = this.tastingTemplate.steps
                console.log('template', templateSteps)
                for (let oneStep in templateSteps) {
                  let step = templateSteps[oneStep]
                  let metrics = step.metrics
                  for (let _metric in metrics) {
                    let metric = metrics[_metric]
                    let weight = metric.weight
                    // console.log('step', weight, metric)
                    // console.log('step', one, metric)
                    console.log('weight', weight)
                    weights[oneStep.toString() + '-' + _metric.toString()] = weight
                  }
                }
                console.log('weights', weights)
                this.weights = weights
              } else {
                setTimeout(() => {
                  setWeights()
                }, 500)
              }
            }
            setWeights()

            this.$store.dispatch('AUTH.addRecentlyViewed', uniqueProductId)

            console.log('coffees1', this.coffees)
            console.log('coffees2', product.options.coffees)
            // this.coffees = product.options.coffees

            this.youtubeVideoID = product.youtubeVideoUrl
            this.enableChat = product.enableChat
            this.enableVideo = product.enableVideo
            this.revealed = product.revealed
            this.scoringLocked = product.scoringLocked
            this.spl = product.spl
            this.scoringStarted = product.scoringStarted || false
            this.scoringEnded = product.scoringEnded || false
            this.sessionStartDate = product.sessionStartDate || false
            this.startsAt = product.startsAt || false
            this.passwordScoring = product.passwordScoring || false
            // console.log('===============>', product)
            // console.log('===============>2', this.scoringStarted)

            if (product.averagesShown) {
              tryForScores()
            }

            console.log('coffees', product.options.coffees)
            console.log('2', this.coffees[0])
            // console.log('3', !this.coffees[0].name)
            if (!this.coffees[0]) {
              console.log('coffees2', product.options.coffees)
              this.coffees = product.options.coffees
            }


            this.enableBlindCupping = product.options.enableBlindCupping
            this.allowViewerAverageControl = product.options.allowViewerAverageControl
            this.revealed = product.revealed
            this.averagesShown = product.averagesShown
            console.log('>> AVERAGES SHOWN', product.averagesShown)
            this.colorMode = product.options.colorMode
            this.colorModeOption = product.options.colorModeOption

            this.tastingTemplate = product.options.selectedTemplateData

            // if (this.myScores == []) {
            if (!this.loaded) {
              console.log('**** =====> SETTING SCORES', this.tastingTemplate)
              this.myScores = this.myScoresSheet(this.tastingTemplate)
            }
            // console.log('myScores',)
            // }

            console.log('((( liveQuestions', product)
            // this.liveQuestions = product.messages

            let l = product.options.selectedTemplateData.steps[0].metrics.length
            let from = product.options.selectedTemplateData.steps[0].metrics[l -1].scoring.from
            let to = product.options.selectedTemplateData.steps[0].metrics[l -1].scoring.to
            // console.log('from',)
            this.staticMarksObject = this.marksObject(from, to)

            // setTimeout(() => {
            this.loaded = true
            // }, 1000)
          })

          console.log('get', productFullDetailsRef)
          // this.reload()


          setTimeout(() => {

            // scores - my scores
            firebaseInstance.database().ref('publicLiveCuppings_Scores/' + uniqueProductId + '/scores/' + uid).on('value', async (snap) => {
              let uid = this.$store.getters['AUTH.uid']
              let productFullDetails = {scores: {[uid]: snap.val()}}
              let average = this.averages
              let product = snap.val()

              console.log('MY SCORES****', uid, product)
              if (product) {
                let p = {scores: {}}
                p.scores[uid] = product
                product = p
                console.log('product1', product)
                if (this.myScores.length == 0) {
                  console.log('here')
                  this.tastingTemplate = product.options ? product.options.selectedTemplateData : false
                  this.myScores = this.myScoresSheet(this.tastingTemplate)              
                }

                let scores
                scores = this.myScores
                let product = productFullDetails

                // this.scoringLocked = product.scoringLocked
                // this.averagesShown = product.averagesShown
                // this.groupDescriptorsShown = product.groupDescriptorsShown
                // this.polarizationShown = product.polarizationShown

                this.numberOfUsers = Object.keys(product.scores || {}).length

                // console.log('myScores1', this.tastingTemplate)
                // console.log('myScores2', this.myScores)
                // console.log('averages', this.averages)
                let newScores = {}
                if (product.scores && product.scores[uid]) {
                  newScores = product.scores[uid].coffees
                }
                for (let n in newScores) {
                  let steps = newScores[n].steps
                  // console.log('steps', steps)
                  for (let i in steps) {
                    let step = steps[i]
                    for (let j in step.metrics) {
                      if (newScores[n] &&
                          newScores[n].steps[i] &&
                          newScores[n].steps[i].metrics[j] &&
                          newScores[n].steps[i].metrics[j].score) {
                      let score = newScores[n].steps[i].metrics[j].score
                        if (scores[n]) {
                          if (scores[n].steps[i].metrics) {
                            if (scores[n].steps[i].metrics[j]) {
                              scores[n].steps[i].metrics[j].score = score
                            } else {
                              scores[n].steps[i].metrics[j] = {score: score}
                            }
                          } else {
                            scores[n].steps[i].metrics = {[j]: {score: score}}
                          }
                        } else {
                          scores[n] = {steps: {[i]: {metrics: {[j]: {score: score}}}}}
                        }
                      }
                    }
                  }
                }

                // get averages per metric
                let metricNumbers = {}
                let metricTotals = {}
                for (let _uid in product.scores) {
                  let newScores = product.scores[_uid].coffees
                  for (let n in newScores) {
                    let steps = newScores[n].steps
                    // console.log('steps', steps)
                    for (let i in steps) {
                      let step = steps[i]
                      for (let j in step.metrics) {
                        let metric = step.metrics[j]
                        if (!metricNumbers[n]) {
                          metricNumbers[n] = {[i]: {}}
                        }
                        if (!metricNumbers[n][i]) {
                          metricNumbers[n][i] = {}
                        }
                        if (!metricTotals[n]) {
                          metricTotals[n] = {[i]: {}}
                        }
                        if (!metricTotals[n][i]) {
                          metricTotals[n][i] = {}
                        }

                        let metricTypeScoring = this.tastingTemplate.steps[i].metrics[j].scoring
                        if (metricTypeScoring.type == 'check-x-times-k') {
                          for (let h in metric.score) {
                            metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + 1
                          }
                          metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
                        } else if (metricTypeScoring.type == 'number-magnitude-k') {
                          console.log('number-magnitude-k', metric.score)
                          metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + parseFloat(metric.score.magnitude) * parseFloat(metric.score.number) * parseFloat(metric.score.k || 1)
                          metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
                        } else {
                          metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + metric.score
                          metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
                        }
                        // let range = metric.max - metric.min                   
                      }
                    }
                  }
                }

                let averages = {}
                let averageCounts = {}

                for (let n in metricNumbers) {
                  let steps = metricNumbers[n]
                  for (let i in steps) {
                    let metrics = steps[i]
                    for (let j in metrics) {
                      let metric = metrics[j]
                      let number = metricTotals[n][i][j]
                      let average = metric/number


                      if (!averages[n]) {
                        averages[n] = {[i]: {[j]: {}}}
                        averageCounts[n] = {[i]: {[j]: 0}}
                      }
                      if (!averages[n][i]) {
                        averages[n][i] = {[j]: {}}
                        averageCounts[n][i] = {[j]: 0}
                      }
                      averages[n][i][j] = average
                      averageCounts[n][i][j] = number                      
                    }
                  }
                }
                // get polarization
                let polarizationTotal = {}
                let polarizationNumber = {}
                for (let _uid in product.scores) {
                  let newScores = product.scores[_uid].coffees
                  for (let n in newScores) {
                    let steps = newScores[n].steps
                    // console.log('steps', steps)
                    for (let i in steps) {
                      let step = steps[i]
                      for (let j in step.metrics) {
                        let metric = step.metrics[j]
                        let metricRange = parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.to) - parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.from)
                        // console.log('METRIC!', this.tastingTemplate.steps[i].metrics[j].scoring.from)

                        if (!polarizationNumber[n]) {
                          polarizationNumber[n] = {[i]: {}}
                        }
                        if (!polarizationNumber[n][i]) {
                          polarizationNumber[n][i] = {}
                        }
                        if (!polarizationTotal[n]) {
                          polarizationTotal[n] = {[i]: {}}
                        }
                        if (!polarizationTotal[n][i]) {
                          polarizationTotal[n][i] = {}
                        }
                        // divide by metric range
                        polarizationNumber[n][i][j] = (polarizationNumber[n][i][j] || 0) + 2*100*Math.abs(metric.score - averages[n][i][j])/metricRange
                        polarizationTotal[n][i][j] = (polarizationTotal[n][i][j] || 0) + 1
                        // let range = metric.max - metric.min                   
                      }
                    }
                  }
                }
                let polarizations = {}

                for (let n in polarizationNumber) {
                  let steps = polarizationNumber[n]
                  for (let i in steps) {
                    let metrics = steps[i]
                    for (let j in metrics) {
                      let metric = metrics[j]
                      let number = polarizationTotal[n][i][j]
                      let average = metric/number


                      if (!polarizations[n]) {
                        polarizations[n] = {[i]: {[j]: {}}}
                      }
                      if (!polarizations[n][i]) {
                        polarizations[n][i] = {[j]: {}}
                      }
                      polarizations[n][i][j] = average

                    }
                  }
                }

                let polarizationsByCoffee = {}
                let polarizationsByCoffeeNumber = {}

                for (let coffee in polarizations) {
                  for (let i in polarizations[coffee]) {
                    for (let j in polarizations[coffee][i]) {
                      polarizationsByCoffee[coffee] = (polarizationsByCoffee[coffee] || 0) + polarizations[coffee][i][j]
                      polarizationsByCoffeeNumber[coffee] = (polarizationsByCoffeeNumber[coffee] || 0) + 1
                    }
                  }
                }

                let polarizationsByCoffeeFinal = {}
                for (let coffee in polarizationsByCoffee) {
                  polarizationsByCoffeeFinal[coffee] = polarizationsByCoffee[coffee] / polarizationsByCoffeeNumber[coffee]
                }

                this.polarizationsByCoffee = polarizationsByCoffeeFinal
                // this.revealed = product.revealed
                // this.averagesShown = product.averagesShown

                setTimeout(() =>{
                  this.myScores = scores
                  this.averageCounts = averageCounts
                  this.averages = averages
                }, 100)

              }
            })
            // scores - all
            // getAllScores()
            // firebaseInstance.database().ref('publicLiveCuppings_Scores/' + uniqueProductId).on('value', async (snap) => {
            //   let productFullDetails = snap.val()
            //   let product = productFullDetails
            //   let uid = this.$store.getters['AUTH.uid']
            //   let average = this.averages

            //   console.log('ALL SCORES****', product)

            //   if (this.myScores.length == 0) {
            //     console.log('here')
            //     this.tastingTemplate = product.options.selectedTemplateData
            //     this.myScores = this.myScoresSheet(this.tastingTemplate)              
            //   }
            //     console.log('product2', product)

            //   let scores
            //   scores = this.myScores

            //   // this.scoringLocked = product.scoringLocked
            //   // this.averagesShown = product.averagesShown
            //   // this.groupDescriptorsShown = product.groupDescriptorsShown
            //   // this.polarizationShown = product.polarizationShown

            //   this.numberOfUsers = Object.keys(product.scores || {}).length

            //   // console.log('myScores1', this.tastingTemplate)
            //   // console.log('myScores2', this.myScores)
            //   // console.log('averages', this.averages)
            //   let newScores = {}
            //   if (product.scores && product.scores[uid]) {
            //     newScores = product.scores[uid].coffees
            //   }
            //   for (let n in newScores) {
            //     let steps = newScores[n].steps
            //     // console.log('steps', steps)
            //     for (let i in steps) {
            //       let step = steps[i]
            //       for (let j in step.metrics) {
            //         if (newScores[n] &&
            //             newScores[n].steps[i] &&
            //             newScores[n].steps[i].metrics[j] &&
            //             newScores[n].steps[i].metrics[j].score) {
            //         let score = newScores[n].steps[i].metrics[j].score
            //           if (scores[n]) {
            //             if (scores[n].steps[i].metrics) {
            //               if (scores[n].steps[i].metrics[j]) {
            //                 scores[n].steps[i].metrics[j].score = score
            //               } else {
            //                 scores[n].steps[i].metrics[j] = {score: score}
            //               }
            //             } else {
            //               scores[n].steps[i].metrics = {[j]: {score: score}}
            //             }
            //           } else {
            //             scores[n] = {steps: {[i]: {metrics: {[j]: {score: score}}}}}
            //           }
            //         }
            //       }
            //     }
            //   }

            //   // get averages per metric
            //   let metricNumbers = {}
            //   let metricTotals = {}
            //   for (let _uid in product.scores) {
            //     let newScores = product.scores[_uid].coffees
            //     for (let n in newScores) {
            //       let steps = newScores[n].steps
            //       // console.log('steps', steps)
            //       for (let i in steps) {
            //         let step = steps[i]
            //         for (let j in step.metrics) {
            //           let metric = step.metrics[j]
            //           if (!metricNumbers[n]) {
            //             metricNumbers[n] = {[i]: {}}
            //           }
            //           if (!metricNumbers[n][i]) {
            //             metricNumbers[n][i] = {}
            //           }
            //           if (!metricTotals[n]) {
            //             metricTotals[n] = {[i]: {}}
            //           }
            //           if (!metricTotals[n][i]) {
            //             metricTotals[n][i] = {}
            //           }
            //           metricNumbers[n][i][j] = (metricNumbers[n][i][j] || 0) + metric.score
            //           metricTotals[n][i][j] = (metricTotals[n][i][j] || 0) + 1
            //           // let range = metric.max - metric.min                   
            //         }
            //       }
            //     }
            //   }

            //   let averages = {}
            //   let averageCounts = {}

            //   for (let n in metricNumbers) {
            //     let steps = metricNumbers[n]
            //     for (let i in steps) {
            //       let metrics = steps[i]
            //       for (let j in metrics) {
            //         let metric = metrics[j]
            //         let number = metricTotals[n][i][j]
            //         let average = metric/number


            //         if (!averages[n]) {
            //           averages[n] = {[i]: {[j]: {}}}
            //           averageCounts[n] = {[i]: {[j]: 0}}
            //         }
            //         if (!averages[n][i]) {
            //           averages[n][i] = {[j]: {}}
            //           averageCounts[n][i] = {[j]: 0}
            //         }
            //         averages[n][i][j] = average
            //         averageCounts[n][i][j] = number                      
            //       }
            //     }
            //   }
            //   // get polarization
            //   let polarizationTotal = {}
            //   let polarizationNumber = {}
            //   for (let _uid in product.scores) {
            //     let newScores = product.scores[_uid].coffees
            //     for (let n in newScores) {
            //       let steps = newScores[n].steps
            //       // console.log('steps', steps)
            //       for (let i in steps) {
            //         let step = steps[i]
            //         for (let j in step.metrics) {
            //           let metric = step.metrics[j]
            //           let metricRange = parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.to) - parseFloat(this.tastingTemplate.steps[i].metrics[j].scoring.from)
            //           // console.log('METRIC!', this.tastingTemplate.steps[i].metrics[j].scoring.from)

            //           if (!polarizationNumber[n]) {
            //             polarizationNumber[n] = {[i]: {}}
            //           }
            //           if (!polarizationNumber[n][i]) {
            //             polarizationNumber[n][i] = {}
            //           }
            //           if (!polarizationTotal[n]) {
            //             polarizationTotal[n] = {[i]: {}}
            //           }
            //           if (!polarizationTotal[n][i]) {
            //             polarizationTotal[n][i] = {}
            //           }
            //           // divide by metric range
            //           polarizationNumber[n][i][j] = (polarizationNumber[n][i][j] || 0) + 2*100*Math.abs(metric.score - averages[n][i][j])/metricRange
            //           polarizationTotal[n][i][j] = (polarizationTotal[n][i][j] || 0) + 1
            //           // let range = metric.max - metric.min                   
            //         }
            //       }
            //     }
            //   }
            //   let polarizations = {}

            //   for (let n in polarizationNumber) {
            //     let steps = polarizationNumber[n]
            //     for (let i in steps) {
            //       let metrics = steps[i]
            //       for (let j in metrics) {
            //         let metric = metrics[j]
            //         let number = polarizationTotal[n][i][j]
            //         let average = metric/number


            //         if (!polarizations[n]) {
            //           polarizations[n] = {[i]: {[j]: {}}}
            //         }
            //         if (!polarizations[n][i]) {
            //           polarizations[n][i] = {[j]: {}}
            //         }
            //         polarizations[n][i][j] = average

            //       }
            //     }
            //   }

            //   let polarizationsByCoffee = {}
            //   let polarizationsByCoffeeNumber = {}

            //   for (let coffee in polarizations) {
            //     for (let i in polarizations[coffee]) {
            //       for (let j in polarizations[coffee][i]) {
            //         polarizationsByCoffee[coffee] = (polarizationsByCoffee[coffee] || 0) + polarizations[coffee][i][j]
            //         polarizationsByCoffeeNumber[coffee] = (polarizationsByCoffeeNumber[coffee] || 0) + 1
            //       }
            //     }
            //   }

            //   let polarizationsByCoffeeFinal = {}
            //   for (let coffee in polarizationsByCoffee) {
            //     polarizationsByCoffeeFinal[coffee] = polarizationsByCoffee[coffee] / polarizationsByCoffeeNumber[coffee]
            //   }

            //   this.polarizationsByCoffee = polarizationsByCoffeeFinal


            //   setTimeout(() =>{
            //     this.myScores = scores
            //     this.averageCounts = averageCounts
            //     this.averages = averages
            //     console.log('test', scores, averageCounts, averages)
            //   }, 100)
            // })
            // descriptors - my descriptors
            console.log('this', 'publicLiveCuppings_Descriptors/' + uniqueProductId + '/descriptors/' + uid)
            firebaseInstance.database().ref('publicLiveCuppings_Descriptors/' + uniqueProductId + '/descriptors/' + uid).on('value', (snap) => {
              console.log('HERE', uid)
              let uid = this.$store.getters['AUTH.uid']
              let productFullDetails = {descriptors: {[uid]: snap.val()}}
              let product = productFullDetails
              let average = this.averages


              // let _d = product ? (product.descriptors ? (product.descriptors[uid] ? product.descriptors[uid] : []) : []) : []
              let _d = product.descriptors ? (product.descriptors[uid] ? product.descriptors[uid] : []) : []

              // console.log('<< >> MY DESCRIPTORS << >>', _d, this.myDescriptors)
              if (this.myDescriptors !== _d) {
                this.loaders['addingDescriptors'] = false
              }
              
              this.myDescriptors = _d


              // console.log('<<< descriptors', product)

              let allDescriptors = product.descriptors || {}
              let descriptorsArray = []
              let descriptorsArray2 = []
              for (let uid in allDescriptors) {
                let userDescriptors = allDescriptors[uid]
                for (let n in userDescriptors) {
                  let coffee = userDescriptors[n]
                  for (let descriptor in coffee) {
                    if (!descriptorsArray[n]) {
                      descriptorsArray[n] = []
                    }
                    let word = coffee[descriptor]
                    let existingWordInArray = descriptorsArray[n].filter(v => v[0] == word)
                    
                    if (existingWordInArray[0]) {
                      let indexOfExistingWord = descriptorsArray[n].indexOf(existingWordInArray[0])
                      descriptorsArray[n][indexOfExistingWord][1] = descriptorsArray[n][indexOfExistingWord][1] + coffee.length - parseInt(descriptor)
                    } else {
                      descriptorsArray[n].push([word, coffee.length - parseInt(descriptor)])
                    }

                  }
                }
              }

              this.descriptorsArray = descriptorsArray
              console.log('descriptorsArray', descriptorsArray)
            })
            // descriptors - all
            firebaseInstance.database().ref('publicLiveCuppings_Descriptors/' + uniqueProductId).on('value', (snap) => {
              let productFullDetails = snap.val()
              let product = productFullDetails
              let uid = this.$store.getters['AUTH.uid']
              let average = this.averages
              this.myDescriptors = product ? (product.descriptors ? (product.descriptors[uid] ? product.descriptors[uid] : []) : []) : []
              console.log('<< descriptors', product)

              let allDescriptors = product ? product.descriptors || {} : {}
              let descriptorsArray = []
              let descriptorsArray2 = []
              for (let uid in allDescriptors) {
                let userDescriptors = allDescriptors[uid]
                for (let n in userDescriptors) {
                  let coffee = userDescriptors[n]
                  for (let descriptor in coffee) {
                    if (!descriptorsArray[n]) {
                      descriptorsArray[n] = []
                    }
                    let word = coffee[descriptor]
                    let existingWordInArray = descriptorsArray[n].filter(v => v[0] == word)
                    
                    if (existingWordInArray[0]) {
                      let indexOfExistingWord = descriptorsArray[n].indexOf(existingWordInArray[0])
                      descriptorsArray[n][indexOfExistingWord][1] = descriptorsArray[n][indexOfExistingWord][1] + coffee.length - parseInt(descriptor)
                    } else {
                      descriptorsArray[n].push([word, coffee.length - parseInt(descriptor)])
                    }

                  }
                }
              }

              this.descriptorsArray = descriptorsArray
              console.log('descriptorsArray', descriptorsArray)
            })
            // messages
            firebaseInstance.database().ref('publicLiveCuppings_Messages/' + uniqueProductId).on('value', (snap) => {
              let product = snap.val()
              console.log(')))', product)
              this.liveQuestions = product ? (product.messages || {}) : {}
            })
          }, 1000)
        } else {
          setTimeout(() => {
            run()
          }, 300)
        }
      }
      run()
    },
    getProductData () {

      // let route = this.$route
      // let productId = route.params.liveSessionId
      // if (productId) {
      //   this.$store.dispatch('AUTH.getLiveCuppingProductDetails', productId).then((product) => {
      //     console.log('product', product)
      //     for (let i in product) {
      //       this[i] = product[i]
      //     }
      //     this.liveQuestions = product.messages
      //     this.loaded = true

      //   })
      // }

    },
    load () {

      if (this.coffees && this.coffees.length == 0) {
        setTimeout(() => {this.load()}, 500)
      } else {
        let width = window.innerWidth
        if (width < 610) {
          console.log('a-')
          this.slidesPerRow = 1
        } else if (width < 1000) {
          console.log('b-')
          this.slidesPerRow = 2
        } else if (width < 1400) {
          console.log('c-')
          this.slidesPerRow = 3
        }
        let l = this.coffees ? this.coffees.length : 0
        // this.slidesPerRow = Math.min(l, Math.floor((width-100)/250)) + 1
        this.slidesPerRow = Math.floor((width-280)/425) + 1
        // if (l == 1 && width < 595) {
          // this.slidesPerRow = 1
        // } else 
        if (this.slidesPerRow == 0) {
          this.slidesPerRow = 1
        } 
        console.log('d-', this.slidesPerRow)

        this.$forceUpdate();
      }
    },
    pulse () {
      if (this.uniqueProductId) {
        let go = () => {
          let now = (new Date()).getTime()
          let uniqueId = this.$store.getters['AUTH.uid']
          firebaseInstance.database().ref('/pulse/' + (this.uniqueProductId || 'f') + '/' + (uniqueId || 'f')).set(now)
        }
        setInterval(() => {
          go()
        }, 30000)
        go()

      } else {
        setTimeout(() => {
          this.pulse()
        }, 1000)
      }
    },
    getPulse () {
      if (this.uniqueProductId) {

        let go = () => {
          let now = (new Date()).getTime()
          let then = (new Date()).getTime() - 30 * 1000
          firebaseInstance.database().ref('/pulse/' + (this.uniqueProductId || 'f')).once('value', (snap) => {
            let count = 0
            let _snap = snap.val()
            for (let one in _snap) {
              if (_snap[one] > then) {
                count = count + 1
              }
            }
            this.viewersCount = count
          })
        }

        setInterval(() => {
          go()
        }, 30000)
        go()


      } else {
        setTimeout(() => {
          this.getPulse()
        }, 1000)
      }
    },
    setParts () {
      let parts = this.$route.params.parts
      this.parts = parts
    },
    goToMySheetWhenReady () {
      if (this.$store.getters['AUTH.myCurrentCupping']) {
        console.log('get', this.$store.getters['AUTH.myCurrentCupping'])
        router.push('/live/' + this.$store.getters['AUTH.myCurrentCupping'])

        let route = this.$route
        let productId = route.params.liveSessionId

        console.log('productId', productId)
        if (productId) {
          if (this.$route.params.parts) {
            this.setParts()
          }
          this.watchProductData()
          this.pulse()
          this.getPulse()
        }

      } else {
        setTimeout(() => {
          this.goToMySheetWhenReady()
        }, 500)
      }
    }




  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Live page created', this.$route.params)

    let route = this.$route
    let productId = route.params.liveSessionId

    console.log('productId', productId)
    if (productId) {
      if (this.$route.params.parts) {
        this.setParts()
      }
      this.watchProductData()
      this.pulse()
      this.getPulse()
    } else {
      // wait for session to load in actions
      this.goToMySheetWhenReady()
    }

  },
  mounted () {
    this.load()
    window.addEventListener('resize', this.load);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.load)
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  $orange: orange;
  $orange2: #de9c25;

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    /*margin-bottom: 10px;*/
    a {
      font-weight: 400;
      font-size: 10px;
      text-decoration: underline;
    }
  }

  $min-height-1: 450px;
  $height-1: calc(50vh - 30px);

  .live-cupping-video {
    border-radius: 5px;
    overflow: hidden;
    width: 600px;
    min-height: $min-height-1;
    height: $height-1;
  }

  @media (max-width: 1200px) {
    .live-cupping-video {
      width: 500px;
    }    
  }

  .live-cupping-top {
    min-height: $min-height-1;
    height: $height-1;
    max-width: 750px;
  }

  .live-wrapper {
    background-color: #292929;
    overflow: auto;
    overflow-x: scroll;
    padding: 15px;
    /*padding-top: 30px;*/
    /*padding-top: 0px;*/
  }
  .add-descriptor-input {
    height: 34px;
    width: 100%;
    border: 1px solid #49494C;
    border-radius: 17px;
    background-color: #FFFFFF;
    margin-bottom: 0;
  }

  .actions {
    align-self: flex-end;
  }

  .ask-a-question-button {
    font-weight: 400;
    border: none !important;
    box-shadow: none !important;
  }

  .cancel-button {
    background-color: transparent !important;
    height: 23px;
    color: #FF2424;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    padding: 0;
    padding-left: 14px;
    padding-right: 14px;
    flex: unset;
  }

  .post-button {
    flex: unset;
    padding: 0;
    height: 23px;
    border-radius: 5px;
    background-color: #D4D4D9;
    color: #959595;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .ask-a-question-input {
    box-sizing: border-box;
    border: 1px solid #888;
    background-color: transparent;
    color: #e9e9e9;
    width: 75%;
    margin-bottom: 0;
  }
  .ask-a-question-input-initials {
    position: absolute;
    text-transform: uppercase;
  }

  .video-meta {
    background-color: #fff;
    height: 75px;
    min-height: 75px;
    padding: 14px 36px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    &.description-open {
      overflow-y: auto;
      justify-content: flex-start;
      /*padding-top: 70px;*/
    }

    h2, p {
      color: #000000;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 24px;
    }

    h2 {
      font-weight: 600;
      font-size: 16px;
    }
  }

  .question-wrap {
    /*height: 40px !important;*/
    color: #444;
  }
  .ask-a-question-input-initials {
    height: 40px;
    width: 40px;
    background-color: #7ADFD2;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-family: Inter;
    font-size: 13.5px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 16px;
    text-align: center;
  }
  .smaller-initials {
    height: 27px;
    width: 27px;
    color: #FFFFFF;
    font-family: Inter;
    font-size: 9.45px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 11px;
    text-align: center;
  }
  .ask-a-question-input {
    height: 40px !important;
    border-color: transparent !important;
    border-radius: 0;
    border-radius: 25.5px;
    background-color: #F3F3F5;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    padding-left: 53px;
  }
  .descriptors-wrap {
    /*flex: 1;*/
    height: calc(100% - 55px);
    display: flex;
    flex-direction: column;
  }
  .descriptors {
    width: 100%;
    /*margin-top: 4px;*/
    padding: 0;
    box-shadow: none;

    & > h4 {
      font-weight: 600;
      margin-bottom: 5px;
    }
    .descriptor-list {
      /*border: 1px solid #888;*/
      flex: 1;

      background-color: transparent;
      color: #e9e9e9;
      width: 100%;
      border-radius: 10px;
      margin-bottom: 4px;
      padding: 10px;

      h5 {
        margin-bottom: 0;
      }

      p {

        /*flex: 1;*/
        text-align: center;
        padding-left: 16px;
        /*padding-right: 10px;*/
        box-sizing: border-box;
        height: 18px;
        border: 1px solid #49494C;
        border-radius: 9px;

        font-size: 14px;
        margin-right: 6px;
        margin-top: 6px;

        color: #49494C;
        font-family: Inter;
        font-size: 10px;
        letter-spacing: 0;
        line-height: 12px;

        span {
          /*border: 1px solid #888;*/
          cursor: pointer;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          max-height: 17px;
          height: 17px;
          line-height: 17px;
          padding-bottom: 1px;
          color: white;
          width: 17px;
          font-size: 12px;
          margin-left: 3px;
          padding: 2px;
          border-radius: 50%;
          background-color: #999;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    /*margin-bottom: 50px;*/

    & > * {
      border-radius: 0;
      /*margin-left: 7.5px;*/
      /*margin-right: 7.5px;*/
    }
  }
  .live-current-step {
    border-radius: 5px;
  }
  .current-step-overlay {
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    z-index: 10000;
    border-radius: 5px;
  }
  $default-coffee-color: #000;
  .bag-title {
    color: #eaeaea;
    font-family: Inter;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
    text-align: left;
  }
  .bag-title-score {
    font-weight: 400;
    margin-top: 1px;
  }
  .inverted-colors {
    .one-coffee-bag {
      /*border-bottom: 1px solid #D8D8D8;*/
    }
    .live-current-step {
      background-color: #fff;
      margin-top: 20px;
    }
    .descriptor-list {
      /*background-color: #f8f8f8 !important;*/
      color: #333;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        /*background-color: #ccc;*/
        span {
          color: #333;
          background-color: #aaa;
        }
      }
    }
    .add-descriptor-input {
      border: 1px solid #888;
      background-color: #f8f8f8;
      color: #333;
    }
    .live-wrapper {
      /*background-color: #eaeaea;*/
      background-color: rgb(239, 239, 240);
    }
    .live-cupping-questions {
      background: $color-white;
      flex: 1;
      border-radius: 5px;
      /*max-height: 410px;*/
    }
    .ask-a-question-button {
      /*background-color: transparent;*/
      /*border: 1px solid #999;*/
      /*color: #888;*/

      &:hover {
        /*background-color: #999;*/
        /*color: white;*/
      }
    }
    .ask-a-question-input {
      border: none;
      color: #444;

      &::placeholder {
        color: #888;
      }
    }

    .bag-title {
      color: $default-coffee-color;
    }

    .one-score-metric-color {
      position: relative;
      &:nth-child(even) {
        background-color: rgba(200,200,212,0.3);
        &::after {
          position: absolute;
          background-color: rgba(200,200,212,0.3);
          bottom: 0;
          left: -12px;
          height: 100%;
          content: ' ';
          width: 12px;
        }
      }
    }

    .one-score-metric {
      /*position: relative;
      &:nth-child(even) {
        background-color: rgba(200,200,212,0.3);
        &::after {
          position: absolute;
          background-color: rgba(200,200,212,0.3);
          bottom: 0;
          left: -25px;
          height: 100%;
          content: ' ';
          width: 25px;
        }
      }*/
    }
  }
  .metric-title {
    .one-score-metric {
      &:nth-child(even) {
        &::after {
          content: '';
          display: none;
        }
      }
    }
  }

  .one-coffee-wrap {
    /*overflow-y: hidden;*/
    min-height: 100%;
    height: auto;
    padding-left: 6px;
    padding-right: 6px;
    /*width: 300px;*/
    display: flex;
    &:first-child {
      .one-score-metric {
        position: relative;
        &:nth-child(even) {
          &::after {
            /*width: calc(100% + 12.5px);*/
            /*left: 0;*/
          }
        }
      }
    }

    &:last-child {
      .one-score-metric {
        position: relative;
        &:nth-child(even) {
          &::after {
            /*width: calc(100% + 12.5px);*/
            /*left: -12.5px;*/
          }
        }
      }
    }
  }
  .cupping-top {
    /*margin-bottom: 15px;*/
    /*background-color: #1d1d1d;*/
    height: 60px;
    width: auto;
    width: 100%;
  }
  .live-splash {
    width: 100%;
    margin-bottom: 4px;
    background-color: #3a3a3a;
    /*max-width: 720px;*/
  }
  .cupping-steps {
    padding: 5px;
    /*orphans: 0;*/
    width: 30%;
    min-width: 220px;
  }
  .cupping-step-name {
    width: 150px;
  }
  .current-step {
    a, p {
      color: $orange;
    }
  }
  .one-coffee {
    /*max-width: 400px;*/
    height: 100%;
    flex-direction: column;
    background-color: #F3F3F5;
    border-radius: 5px;
  }
  .one-coffee-bag {
    /*background-color: #999;*/
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: relative;
    height: 70px;
    text-transform: capitalize;
    text-align: center;
    padding-right: 15px;
    padding-left: 15px;
    border-bottom: 1px solid #D8D8D8;

    &::after {
      position: absolute;
      background-color: #D8D8D8;
      bottom: -1px;
      left: -25px;
      height: 1px;
      content: ' ';
      width: 25px;
    }
  }
  .blue-bag {
    $bag-blue: #0366bf;
    .one-coffee-bag {
      background-color: $bag-blue;
    }
    .bar-fill {
      background-color: $bag-blue;
    }
  }
  .green-bag {
    $bag-green: #01886a;
    .one-coffee-bag {
      background-color: $bag-green;
    }
    .bar-fill {
      background-color: $bag-green;
    }
  }
  .yellow-bag {
    $bag-yellow: #f7c132;
    .one-coffee-bag {
      background-color: $bag-yellow;
    }
    .bar-fill {
      background-color: $bag-yellow;
    }
  }
  .orange-bag {
    $bag-orange: #fc642c;
    .one-coffee-bag {
      background-color: $bag-orange;
    }
    .bar-fill {
      background-color: $bag-orange;
    }
  }
  .group-bar-fill {
    opacity: 0.6;
  }
  $ww: 120px;
  .coffees {
    position: relative;
    max-width: calc(100% - #{$ww}) !important;
  }
  .coffees-2 {
    width: calc(100% - #{$ww}) !important;
  }
  .coffee-my-things {
    height: calc(100% - 70px);
  }
  .cupping-step {
    display: flex;
    height: 100%;
    /*margin-bottom: 10px;*/
    color: white;
    font-size: 16px;
    /*padding: 15px;*/
    /*padding-top: 5px;*/
    padding-left: 0;
    padding-right: 0;
    /*margin-top: 15px;*/
    /*padding-top: 65px;*/
    /*margin-bottom: -25px;*/
    flex-wrap: wrap;

    &:last-child {
      margin-bottom: 0;
    }

  }

  .coffee-my-things-title {
    margin-right: 0;
    width: $ww;
    padding: 0 !important;
  }
  .cupping-step1 {
    margin-bottom: 8px;
    /*width: 286px;*/
    /*background-color: #333;*/

    &:first-child {
      margin-bottom: 0;
    }
  }
  .one-score-metric {
    /*margin-bottom: 12px;*/
    height: 75px;

    &:nth-child(even) {
      /*background-color: #3d3d3d;*/
    }
  }

  .one-score-metric-name {
    margin-bottom: 0;
    height: 75px;
    /*width: 80px;*/
  }
  .step-title {
    cursor: pointer;
    height: 50px;
    position: absolute;
    width: 100%;
    left: 0;
    transform: translateY(-60px);
    padding-left: 15px;
    padding-right: 15px;
    background-color: #222;
  }
  .current-step-title {
    background-color: $orange2;
  }
  .one-score-select {

  }
  .metric-input {
    background-color: grey;
    font-size: 24px;
    color: white;
    text-align: center;
    margin-left: 20px;
    width: 50px;
    height: 50px;
    padding: 4px;
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    /*input[type=number] {*/
      -moz-appearance: textfield;
    /*}*/
  }
  .live-cupping-questions {
    background-color: #3a3a3a;
    margin-left: 20px;
  }
  .live-cupping-top-below {
    /*margin-top: 10px;*/
  }
  .ask-a-question {
    padding: 15px;
    height: 95px;
    border-bottom: 1px solid #DBDBDB;
  }
  input {
    background-color: white;
    padding: 10px;
    font-size: 14px;
    /*margin-bottom: 20px;*/
  }

  .increment {
    button {
      width: 30px;
      height: 30px;
      background-color: #666;
      /*padding: 10px;*/
      font-size: 40px;
      color: #bbb;
      border-radius: 10px;
    }
    p {
      width: 20px;
      min-width: 20px;
      display: block;
      font-size: 22px !important;
      cursor: pointer;
      font-weight: 400 !important;    
    }
  }
  .increment-down {
    margin-right: 2px;
    p {
      text-align: left !important;
    }
  }
  .increment-up {
    margin-left: 2px;
    p {
      text-align: right !important;
    }
  }
  .questions-list-wrapper {
    flex: 1;
    max-height: 335px;
    padding: 20px 15px 5px;
    margin-bottom: 15px;
    overflow-y: auto;


    $scrollbar-color2: grey;

    $scrollbarBG2: transparent;
    $thumbBG2: #EAEAEA;

    &::-webkit-scrollbar {
      width: 11px;
    }
    & {
      scrollbar-width: thin;
      scrollbar-color: $thumbBG2 $scrollbarBG2;
    }
    &::-webkit-scrollbar-track {
      background: $scrollbarBG2;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: $thumbBG2 ;
      /*border-radius: 0;*/
      /*border: 3px solid $scrollbarBG;*/
    }
  }
  .live-qupping-questions-list {
    /*overflow-y: auto;*/
    justify-content: flex-end;
    /*max-height: 195px;*/
  }
  .question-plus-one {
    cursor: pointer;
    margin-left: 8px; 
    color: #676767;

    &:hover {
      color: #0366bf;
    }
  }
  #container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }
  .rating-bar {
    height: 12px;
  }
  .my-rating {
    height: unset;
  }
  .bar-fill {
    height: 100%;
    background-color: #D0D0DE;
    transition: width 1.25s ease;
  }
  .step-description {
    /*margin-bottom: 30px;*/
    /*background-color: #333;*/
    /*padding: 10px;*/
    /*margin-top: 20px;*/

    h2 {
      font-size: 24px;
      font-weight: 600;
    }
    p {
      /*margin-top: 10px;*/
      /*text-align: right;*/
      font-size: 18px;
    }
  }
  $word-cloud-size: 125px;
  .word-cloud {
    padding: 20px;
    height: $word-cloud-size;
    position: relative;

/*    background-color: rgba(200,200,212,0.3);
    &::after {
      position: absolute;
      background-color: rgba(200,200,212,0.3);
      bottom: 0;
      left: -25px;
      height: 100%;
      content: ' ';
      width: 25px;
    }*/

  }
  .word-cloud-title {
    height: $word-cloud-size;
  }
  .descriptors-add {
    margin-bottom: 15px;
    margin-left: 13px;
    margin-right: 13px;
  }
  .horizontal-scoring-view {
    .smaller-step {
      /*max-width: $scoring-box-size/2 + 3.5px !important;*/
    }
    .step-title {
      display: none;
    }
    & > .coffees {
    flex-direction: column;
      & > .one-coffee {
        width: 100%;
        display: flex;
        flex-direction: row;
        /*height: $scoring-box-size;*/
        margin-bottom: 40px;
        height: unset;

        &:last-child {
          margin-bottom: 0;
        }

        .coffee-my-things {
          display: flex;
          flex-direction: row;
          flex: 1;

          .cupping-step {
            margin-top: 0;
            flex: 1;
            padding: 10px;
            /*height: $scoring-box-size;*/
            /*max-width: $scoring-box-size + 7px;*/
            border: 1px solid #555;

            .descriptors {
              margin-bottom: 0;
            }

            .word-cloud, .descriptor-list, .descriptors-add {
              max-width: 305px;
            }

            .one-score-metric {
              /*max-width: $scoring-box-size;*/
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  .wrapper-2 {
    display: flex;
    justify-content: center;
    /*left: 15px;*/
    /*top: 15px;*/
    /*width: calc(100% - 30px);*/
  }
  $base-font-size: 16px;

  .scale-horizontal {
    width: 100%;
    padding-top: 6px;
    padding-right: 7.5px;
    padding-left: 7.5px;

    p {
      font-size: $base-font-size;
      font-weight: 600;
      text-align: left;
    }
  }
  .scale-horizontal-2 {
    width: 100%;
    padding-top: 15px;

    p {
      font-size: $base-font-size;
      font-weight: 600;
      text-align: left;
    }    
  }
  .scale-vertical {
    width: 20%;
    height: 50%;
    p {
      font-size: $base-font-size;
    }
  }
  .descriptors-vertical {
    width: 60%;
    p {
      font-size: $base-font-size;
    }
  }
  .roast-level-vertical {
    p {
      font-size: $base-font-size;
      font-weight: 600;
      text-align: left;
    }
  }
  .one-score-title {
    pointer-events: none;
    text-align: center; 
    /*margin-bottom: 12px;*/

    /*margin-bottom: 30px;*/
    /*margin-top: 16px;*/
    z-index: 10;
    p {
      font-size: 12px;
    }
  }
  .one-score-metric {
    /*margin-top: 10px;*/
  }
  .one-score-metric:first-child {
    .one-score-title {
      /*margin-top: 0;*/
    }
  }
  .sheet-option {
    /*margin-bottom: 4px;*/
    /*margin-left: 24px;*/

    &:first-child {
      margin-left: 0;
    }
    input {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    p {
      font-size: 12px;
    }
  }
  .cupping-with {
    /*margin-bottom: 15px;*/
  }
  .step-description {
    font-size: 14px;
  }
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 15px;
  }
  .reply {
    font-size: 12px;
    cursor: pointer;
    margin-left: 8px;
  }
  .reply-to-question-wrap {
    padding-left: 20px;
  }
  .mb15 {
    margin-bottom: 10px;
  }
  .reply-to-question {
    font-size: 12px;
  }
  .viewer-question-text {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .icons-question {
    width: 18px;
    height: 18px;
    margin-right: 8px; 
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    & > img {
      width: 18px;
      height: 18px;
      display: none;
    }

    &:hover {
      & > img {
        display: block;
      }
    }

    div {
      height: 5px;
      width: 5px;
      border-radius: 50%;
      background-color: #444;
    }
  }

  .cupping-discussion-no-video .live-cupping-questions {
    margin-bottom: 16px;
    overflow-y: auto;
  }

  @media (max-width: 1125px) {
    .wrapper-2 {
      flex-direction: column;
    }

    .live-cupping-top {
      max-width: unset;
    }

    .mro {
      margin-right: 0 !important;
      margin-bottom: 16px !important;
      margin-top: 0 !important;
    }

    .questions-list-wrapper {
      max-height: 290px;
    }
    .live-cupping-video {
      height: calc(33.33vh - 30px);
      width: 100%;
      min-width: 100%;
    }
    .live-splash {
      flex-direction: column;
    }
    .live-cupping-top {
      /*width: 100%;*/
      min-height: unset;
      max-height: calc(50vh - 30px);
    }
    .live-cupping-top-below {
      width: 100%;
    }
    .live-cupping-questions {
      width: 100%;
      margin-left: 0;
      margin-top: 15px;
      max-height: 435px !important;
    }
    .ask-a-question {
      height: 75px;
      margin-top: 5px;
    }
    .coffee-my-things {
      /*padding-left: 20px;*/
      /*padding-right: 20px;*/
    }
  }
  .live-current-step {
    padding: 25px;
    padding-right: 13px;
    position: relative;
    &::after {
      content: ' ';
      background-color: #fff;
      position: absolute;
      height: 100%;
      width: 12px;
      top: 0;
      right: 6px;
      z-index: 1;
    }
  }
  .controls-and-description {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .metric-title {
    height: 100%;
    /*width: 100px;*/
  }
  .metric-title-name {
    font-weight: 600;
    display: flex;
    justify-content: center;
    /*align-items: center;*/
    margin-bottom: 0;

    p { 
      color: #000000;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
      text-align: right;

      &:first-child {
        font-weight: bold;
      }
    }

    & > div {
      height: 100%;
    }
  }
  .special-metric {
    justify-content: flex-end;
    align-items: center;
  }
  .add-descriptor-button {
    height: 18px;
    width: 18px;
    max-height: 18px;
    max-width: 18px;
    margin-left: 9px;
    padding: 0 !important;

    background-image: url(../../static/images/circle-plus.svg);
    background-position: center;
    background-color: transparent !important;
    box-shadow: none !important;
    background-size: contain !important;
    background-repeat: no-repeat !important;
  }
  .space {
    /*height: 10px;*/
  }
  h5 {
    margin-bottom: 6px;
  }
  .host-view-top {
    margin-bottom: 10px;
  }
  .host-quick-actions {
    /*margin-left: 6px;*/
    cursor: pointer;
  }
  .nobg {
    background-color: transparent !important;
    height: 70px;
    padding-left: 0;
    padding-right: 30px;
    
    &::after {
      /*width: calc(100% + 12.5px);*/
      content: '';
      left: 0;
    }
  }

  .color-1 {
    /*background-color: #0366bfed;*/
    .coffee-image.initials {
      background-color: #000;
    }
  }

  .color-2 {
    /*background-color: #01886aed;*/
    .coffee-image.initials {
      background-color: #E93333;
    }
  }

  .color-3 {
    /*background-color: #f7c132ed;*/
    .coffee-image.initials {
      background-color: #28C1EA;
    }
  }

  .color-4 {
    /*background-color: #fc642ced;*/
    .coffee-image.initials {
      background-color: #9F31E3;
    }
  }

  .coffees.color-1 {
    & > div {
      & > div {
        & > div:nth-child(4n + 1) {
          .one-coffee-bag {
            background-color: #0366bfed;
          }
        }
        & > div:nth-child(4n + 2) {
          .one-coffee-bag {
            background-color: #01886aed;
          }
        }
        & > div:nth-child(4n + 3) {
          .one-coffee-bag {
            background-color: #f7c132ed;
          }
        }
        & > div:nth-child(4n + 4) {
          .one-coffee-bag {
            background-color: #fc642ced;
          }
        }
      }
    }
  }
  .coffee-image {
    /*width: 100%;*/
    height: 50px;
    object-fit: contain;
    margin-right: 10px;
  }
  .end-reply {
    font-size: 12px;
    margin-left: 10px;
    color: #555;
    cursor: pointer;
  }
  .smaller-text {
    font-size: 0.65em !important;
    font-weight: 400;
  }

  .my-scores-number-magnitude-k {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 16px;

    p {
      margin-left: 8px;
      margin-right: 8px;
    }

    .magnitude-x {
      margin: 0;
      line-height: 15px;
      font-size: 15px;
      transform: translateY(-12px) rotate(45deg);
      /*font-family: 'CA SaygonText', sans-serif;*/
    }
  }

  .number-magnitude-k-k {
    margin: unset;
    color: #000000;
    font-family: Inter;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 12px;
  }

  .number-magnitude-k-subheading {
    font-size: 12px;
  }

  .lift_1 {
    transform: translateY(-10px);
  }

  .lift_2 {
    font-size: 10px;
    transform: translateY(-12px);
  }
  
  .lift_3 {
    margin-right: 0 !important;
  }

  .nmk-input {
    width: 56px;
    text-align: center;
    background: none;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #49494C;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    height: 18px;
    padding: 1px 2px;
    margin-bottom: 0;
  }

  /* Chrome, Safari, Edge, Opera */
  .nmk-input::-webkit-outer-spin-button,
  .nmk-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  .nmk-input[type=number] {
    -moz-appearance: textfield;
  }

  .initials {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    background-color: $default-coffee-color;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      text-transform: uppercase;
      color: #FFFFFF;
      font-family: Inter;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 1em;
      text-align: center;
    }
  }

  .descriptors-wrap {
    padding: 0 !important;
    box-shadow: none !important;
    border: none !important;
    width: 100% !important;
    height: 100%;
  }

  .legend-text {
    color: #49494C;
    font-family: Inter;
    font-size: 10px;
    letter-spacing: 0;
    line-height: 12px;
  }

  .legend-square {
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }

  .average-score-square {
    background-color: #DBDBE2;
  }

  .my-score-square {
    /*background-color: #A3A3F5;*/
    background-color: #ADADFF;
  }

  .mt7 {
    margin-top: 7px;
  }

  .add-coffee-popup-inner {
    width: 100%;
    max-width: 330px;
    padding-right: 0 !important; 
  }

  .whole-page-box-global {
    padding: 0;
  }

  .popup-title-section {
    height: 46px;
    padding: 16px 23px 13px;
    border-bottom: 1px solid #DBDBDB;

    h3 {
      color: #000000;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      font-weight: 600;
      line-height: 17px;
    }
  }

  .popup-data-section {
    padding: 23px;
  }
  .settings {
    .sheet-option {
      margin-top: 22px;

      p {
        color: #49494C;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 15px;
      }

      &:first-child {
        margin-top: 0;
      }
    }
  }

  .section-title {
    color: #000000;
    font-family: Inter;
    font-size: 14px !important;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 17px;
  }

  .delete-descriptor {
    margin-left: 8px;
    width: 12px;
    height: 12px;
    object-fit: contain;
    margin-right: 2px;
    transform: rotate(45deg);
  }

  .minus-nmk-input {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    /*padding-left: 1px;*/
    padding-bottom: 1px;
    height: 15px;
    width: 15px;
    color: #49494C;
    border: 1px solid #49494C;
    line-height: 1em;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      height: 9px;
      width: 9px;
      overflow: hidden;
    }
  }

  .ml_x {
    margin-left: 8px;
  }
  .mr_x {
    margin-right: 8px;
  }

  .nmk-one-score-select {
    transform: translateY(3px);
  }

  .user-question {
    border-radius: 5px;
    margin-bottom: 18px;
  }

  .user-question-top {
    position: relative;
    background-color: #F3F3F5;
    padding: 9px 13px;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  ._posrel {
    position: relative !important;
  }
  .question-user-name-location {
    margin-left: 12px;
    p {
      color: #000000;
      font-family: Inter;
      font-size: 12px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 15px;

      &:first-child {
        font-weight: 600;
        color: black;
      }
    }
  }
  .question-user-name-location-2 {
    margin-left: 0;
  }

  .user-comment {
    margin-top: 13px;
    margin-bottom: 3px;
    color: #000000;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .like-and-comment {
    color: #959595;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
    margin-left: 4px;
  }

  .comment-icon {
    margin-left: 30px;
  }

  .questions-replies {
    margin-top: 15px;
    color: #49494C !important;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .ml15 {
    margin-left: 15px;
  }

  .mr15 {
    margin-right: 15px;
  }

  .question-bar {
    .user-question-top {
      margin-bottom: 0;
    }
  }

  .active-question-bar {
    position: absolute;
    height: 152px;
    width: calc(100%);
    z-index: 10;
    background-color: white;

    .question-bar {

    }
  }

  .active-live-cupping-questions {
    /*margin-top: 95px;*/
  }

  .active-post-button {
    background-color: #56B4F2;
    color: white;
  }

  .live-qupping-questions-list {
    scrollbar-color: grey;

    $scrollbarBG: transparent;
    $thumbBG: #C1C1C1;

    &::-webkit-scrollbar {
      width: 11px;
    }
    & {
      scrollbar-width: thin;
      scrollbar-color: $thumbBG $scrollbarBG;
    }
    &::-webkit-scrollbar-track {
      background: $scrollbarBG;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background-color: $thumbBG ;
      /*border-radius: 0;*/
      /*border: 3px solid $scrollbarBG;*/
    }
  }

  .o005 {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }

  .scoring-locked-metric {
    .vue-slider-ltr {
      /*opacity: 0.7;*/
    }
    .increment {
      opacity: 0;
    }
    .vue-slider-dot-tooltip {
      opacity: 1;
    }
    pointer-events: none;
    cursor: default;
    /*background-color: #00000011;*/
  }

  .descriptor-x-locked {
    /*padding-left: 0 !important;*/
    padding-right: 16px;
  }

  @media (max-width: 880px) {
    .video-meta {
      padding-left: 15px;
      padding-right: 15px;
      height: unset;
      &.description-open {
        overflow-y: unset;
        /*padding-top: 15px;*/
      }
    }
    iframe {
    }
    .live-cupping-video {
      height: unset;
      min-height: unset;
      border-radius: 0;
    }
    .live-wrapper {
    }
    .coffee-my-things {
    }
    .coffee-my-things-title {
      width: 80px;
    }
    .nobg {
      padding-right: 0;
    }
    .legend-text {
      max-width: 43px;
      text-align: left;
    }
    .coffees2, .coffees-2 {
      max-width: calc(100% - 80px) !important;
    }
    .live-current-step {
      padding: 15px;
      padding-right: 6px;

      &::after {
        right: 0;
        width: 12px;
        border-top-right-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
  }

  @media (max-width: 420px) {
    .live-wrapper {
      padding-left: 0;
      padding-right: 0;
    }
    .live-current-step {
      /*padding-left: 0;*/
      /*padding-right: 0;*/
    }
    .live-current-step {
      &::after {
        right: unset;
        width: 12px;
        left: calc(100% - 12px);
        /*display: none;*/
      }
    }
    .one-coffee-wrap {
      /*padding-right: 0;*/
      padding-left: 0;

      /*margin-right: 12px;*/
      /*margin-left: -12px;*/
    }
    .one-score-metric-color {
      &:nth-child(even)::after {
        width: 0px !important;
        /*left: 0px !important;*/
      }
    }
    .one-score-metric-name {
      padding-right: 8px;
    }
    .metric-title-name {
      padding-left: 5px;
      p {
        word-break: break-all;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;

      }
    }
    .live-current-step {
      border-radius: 0;
    }
  }
  @media (max-width: 370px) {
    .live-current-step {
      padding-right: 0 !important;
      padding-left: 6px !important;
    }
    .one-coffee-wrap {
      padding-right: 6px !important;
      /*padding-left: 6px !important;*/
    }
    .live-current-step {
      &::after {
        right: unset;
        width: 6px;
        left: calc(100% - 6px);
        /*display: none;*/
      }
    }
  }

  .comment-full {
    margin-left: 5px;
    margin-right: 5px;
  }

  .comment-box {
    margin-top: 14px;
    margin-bottom: 0;
  }

  .user-question-bottom {
    height: 15px;
  }

  .question-comments {
    margin-top: 12px;
  }

  .full-comment-text {
    margin-top: 5px;
    color: #000000;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }
  .back-from-question {
    color: #56B4F2;
    font-family: Inter;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
  }

  .cupping-discussion-no-video {
    height: 300px;
    min-height: 300px;
    .live-cupping-questions {
      margin-left: 0;
      margin-top: 0;
    }
  }
  .cupping-discussion-no-chat {
    width: 100%;
  }

  .no-video-no-chat {
    margin-top: 0 !important;
  }

/*  .ask-a-question {
    &:focus {
      background-color: grey;
    }
  }*/

  .custom-nav {
    padding: 0 !important;
    position: fixed !important;
    border-radius: 50%;
    bottom: 38vh;
    cursor: pointer;
    font-size: 40px;
    line-height: 40px;
    background-color: #ffffff89;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 10;
    width: 40px;
    height: 40px;

    &:active {
      background-color: #00000089 !important;
      border: 1px solid #ffffffaa !important;
      color: white !important;
    }

  }


  .nav-prev {
    left: 10px !important;
    transform: unset !important;
    /*padding-right: 3px !important;*/
    padding-bottom: 2px !important;
  }
  .nav-next {
    right: 10px !important;
    /*padding-left: 3px !important;*/
    transform: unset !important;
  }

  .no-top-margin {
    margin-top: 0 !important;
  }

  .delete-comment {
    cursor: pointer;
    position: absolute;
    height: 10px;
    top: 6px;
    right: 10px;
    opacity: 0.75;

    i {
      font-size: 14px;
      margin-left: 4px;

      &:first-child {
        font-size: 12px;
      }
    }
  }
  .viewers-count {
    width: 100%;
    font-size: 10px;
    margin-top: 8px;
  }

  .mro {
    margin-left: 0;
    margin-right: 20px;
  }

  .settings-title {
    margin-top: 16px;
    margin-bottom: 0;
  }

  ._mt0 {
    margin-top: 8px !important;
  }

  ._mt00 {
    margin-top: 0 !important;
  }

  .switch-1 {
    height: 17px;
  }
  .start {
    width: 34px;
    text-align: center;
    cursor: pointer;
    background-color: #44c96d;
    border-radius: 6px;
    font-size: 12px !important;
    color: white !important;
    font-weight: 600;
  }
  .started {
    width: 34px;
    text-align: center;
    font-size: 20px !important;
  }
  .session-not-started {
    transform: translateY(20px);
  }
  .session-will-start {
    /*margin-bottom: 15px;*/
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 0px;
    padding-bottom: 10px;
    /*height: 24px;*/

    p {
      font-size: 14px;
      text-align: center;
      /*margin-bottom: 15px;*/

      span {
        &:first-child {
          font-size: 12px;
          /*margin-right: 6px !important;*/
          /*margin-bottom: 2px;*/
        }
        &:last-child {
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }

  .spinning-button {
    pointer-events: none;
    animation-name: spin;
    animation-duration: 5000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }


  @keyframes spin {
      from {
          transform:rotate(0deg);
      }
      to {
          transform:rotate(360deg);
      }
  }

  .check-x-boxes {
    p {
      font-size: 12px;
      color: grey;
      font-family: 'CA SaygonText', sans-serif;
    }
    input {
      width: 15px;
      height: 15px;
      margin-left: 8px;
      margin-right: 8px;
      border-radius: 5px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .averages-bars {
    position: absolute;
    width: 100%;
    height: 20px;
    left: 0;
    bottom: 0;
    padding-right: 30px;
    padding-left: 30px;
    /*z-index: -1;*/
  }

  .averages-bar {
    background-color: #4a4a4a33;
    /*border-top-right-radius: 2px;*/
    /*border-top-left-radius: 2px;*/
    /*border-top: 1px solid #22222222;*/
    /*border-bottom: none;*/
  }

  h3.pre-session {
    margin-right: 10px;
    /*margin-bottom: 6px;*/
    /*margin-bottom: 6px;*/
    /*margin-bottom: 15px;*/
  }

  .will-start-top {
    flex-wrap: wrap;
  }

  .starts-at-desctiption {
    font-size: 14px;
    font-family: Inter;
    margin-top: 6px;
    text-align: left !important;
  }

  .starts-at-button {
    font-family: Inter;
    background-color: $color-primary;
    padding: 4px 8px;
    border-radius: 5px;
    color: white;
    font-weight: 700;
    /*margin-bottom: 6px;*/
  }
  .shown-description {
    width: 100%;
    margin-bottom: 9px;
    text-align: left !important;
    font-weight: 400 !important;
  }
  .show-hide-description {
    font-weight: 400 !important;
    font-size: 12px;
    line-height: 12px;
    /*margin-left: 8px;*/
    display: flex;
    /*text-decoration: underline;*/
    align-items: center;
  }

  .password-scoring {
    /*margin-top: 15px;*/

    p {
      font-size: 10px;
      line-height: 12px;
      padding: 4px;
      background-color: #DDD;
      border-radius: 5px;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .waiting-for-host-text {
    text-align: left !important;
    width: 100%;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  @media (max-width: 1200px) {
    .chat-outer {
      flex: 3;
    }
    .host-box {
      flex: 2;
      min-width: 275px;
    }
  }
  .mb_x {
    margin-bottom: 6px;
  }
  .mb_y {
    margin-bottom: 12px;
  }

  $mini-button-width: 130px;

  .mini-button {
    padding: 4px 6px;
    background-color: $color-primary;
    width: $mini-button-width;
    min-width: $mini-button-width;
    max-width: $mini-button-width;
    border-radius: 4px;
    color: white !important;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
    border: 1px solid $color-primary;
  }

  .mini-button-2 {
    background-color: transparent;
    color: $color-primary !important;
  }

  .mtz {
    margin-top: 15px !important;
  }

  h3, .h3 {
    max-width: 300px;
  }

  .scoresheet-template-select {
    width: 100%;
    max-width: 300px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .action-icon {
    height: 16px;
    margin-left: 6px;
    /*margin-bottom: 10px;*/
  }

  .mb_xy {
    margin-bottom: 6px;
  }

  .sheet-actions {
    margin-bottom: 6px;
    margin-top: 6px;
  }

  .save-button {
    text-decoration: underline;
    font-size: 10px;
    line-height: 1em;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 50px;
    /*border: 1px solid #000;*/
    color: #000;
    border-radius: 5px;
  }

  .edit-coffee-name {
    margin-left: 6px;
    height: 11px;
  }


  .add-coffee-popup-inner {
    margin-left: 30px;
    margin-right: 30px;
    & > * {
      width: 100%;
    }
  }
  .add-coffee-popup-inner {
    /*padding-right: 10px !important;*/
    max-height: 100vh;
    overflow-y: auto;
  }
  @media (max-width: 1020px) {
    .add-coffee-popup {
      width: 100%;
    }
    .add-coffee-popup-inner {
      height: 100vh;
      width: 100% !important;
      max-width: unset !important;
      border-radius: 0;
      margin: 0;
    }
  }

  @media (max-width: 440px) {
    .add-coffee-popup-inner {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .back-arrow-main {
    margin-bottom: 20px;
    margin-top: 5px;
  }

  .input-a {
    max-width: 540px;
    border-color: #efefef !important;
    background-color: #fff;
    font-size: 14px;
    padding: 12px 10px;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: 'Rubik', 'sans-serif';
    color: #2b2b2b;
    border-radius: 6px;
  }

  .sheet-actions {
    .show-hide-description {
      color: #5C5C5C;
      font-family: Inter;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 15px;
    }
  }

  .mt_x {
    margin-top: 8px;
  }

  .mt_y {
    margin-top: 10px;
  }

  .add-user-text {
    font-size: 12px !important;
    margin-left: 4px;
  }

  .edit-icon {
    width: 12px;
    margin-left: 6px;
  }

  .no-max-width {
    max-width: unset !important;
  }

  .edit-template-name {
    margin-bottom: 6px;
    input {
      margin-bottom: 0;
    }
    .button-1 {
      max-width: 150px;
      margin-left: 10px;
    }
    .cancel-save {
      font-family: Inter;
      color: $color-primary;
      /*font-weight: 600;*/
      margin-left: 20px;
      font-size: 14px !important;
    }
  }
  .save-description {
    margin-top: 10px;
    margin-bottom: 10px;

    &-button {
      max-width: 120px;

      &:last-child {
        margin-left: 10px;
        background-color: transparent;
        color: $color-primary !important;
        box-shadow: none !important;
      }
    }
  }
  .edit-scoresheet-description {
    padding: 10px;
    font-family: Inter;
    border-color: #ddd;
    border-radius: 6px;
  }

  .edit-description {
    color: $color-primary;

    &.cancel {
      color: #676767;
      margin-left: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Live2.vue